import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import DocumentTitle from "react-document-title";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import { ReactSortable } from "react-sortablejs";
import { BsyUtils } from "../../../utils/Utils";
import BsyDashContainer from "../../dash/BsyDashContainer"; //应用访问
import BsySelect from "../../BsySelect";
import BsyMsgBubble from "../../BsyMsgBubble";
import BsyAlert from "../../BsyAlert";
import BsyDashboardFlowFilter from "../BsyDashboardFlowFilter";
import BsySLoading from "../../BsySLoading";
import BsyDataManage from "../../BsyDataManage";
import { BsyConfig } from "../../../global/BsyConfig";
import { BsyWidget } from "../../BsyWidget";
import BsySearchInput from "../../BsySearchInput";
import BsyFormPane from "../../BsyFormPane";
import BsyMaskLayer from "../../BsyMaskLayer";
import isNil from "lodash/isNil";
import {
  _submitSign,
  _switchBackNode,
  _switchSubmit,
  _switchTransferChargers,
  generateQuickBtn,
} from "./flowUtils";
import BsySystemRightMenu from "../../BsySystemRightMenu";
import { createTooltip } from "../../../utils/createTooltip";
import BsyAlertMenu from "../../BsyAlertMenu";
import { setPageTitle } from "../../../utils/setPageTitle";
import { dayjsUtils } from "../../../utils/dayjsUtils";
import { getAfterSuffix } from "../../../utils/getAfterSuffix";

class Content extends Component {
  FlowMenuData = {
    todo: {
      id: "todo",
      text: React.language("flow.todo"),
      type: "flow",
    },
    create: {
      id: "create",
      text: React.language("flow.visit.create"),
      type: "flow",
    },
    cc: {
      id: "cc",
      text: React.language("flow.my.cc"),
      type: "flow",
    },
    transactors: {
      id: "transactors",
      text: React.language("flow.my.transactors"),
      type: "flow",
    },
  };

  state = {
    titleName: this.props.appName || "",
  };

  constructor(props) {
    super(props);
    this.content = React.createRef();
    this.flowContent = React.createRef();
    this.path = React.createRef();
    this.entryname = React.createRef();
    this.breadcrumb = React.createRef();
    this.state = {
      appId: props.appId,
      entryId: props.entryId,
      type: props.type,
      showContentEmpty: false,
      dashConfig: {},
      allComponentDash: {},
      filterList: [],
      flowFormData: [],
      avatarMap: {},
      nameMap: {},
      selectForm: {},
      count: 0,
      filter: [],
      fields: [],
      updateTime: -1,
      allFilterList: [],
      showFilter: false,
      showAllFilter: false,
      isBatchForward: false,
      isAllSelectBatch: 0, // 0 未选中 / 1 部分选择 / 2 全部选择
      page: 0,
      isBatchForwardNum: 0,
      batchForwardList: [],
      hasScroll: true,
      scrollDataLength: 0,
      loadSuccess: false,
      isDashFull: false,
      isExpand: false,
      isLoading: false,
      is_dock_form: false,
      isMore: true,
      rel: "and",
      formAuthGroups: [],
      authGroups: null,
      editAuth: props.editAuth,
      appType: props.appType,
      isSelectAllFlow: true,
      isShowCloseTip: false //钉钉状态下关闭图标
    };
    this.dashContent = React.createRef();
    this.renderIndex = 0;
    this.renderFlowIndex = 0;
    this.renderFlowFilterIndex = 0;
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;

    this.allFlowNode = {
      appId: this.state.appId,
      count: 0,
      icon: 39,
      name: React.language("all.to.do"),
    };
  }

  loadFirst = false;

  componentWillUnmount() {
    this.hideTooltip();
  }

  componentDidMount() {
    const { appId, entryId, type, } = this.state;
    let that = this;
    this.props?.onGetContext?.(this);
    window.addEventListener("resize", this.onfullscreenchange, false);
    // // 监听鼠标移动事件
    // document.addEventListener('mousemove', function (event) {
    //   // 假设顶部范围为 0 到 20 像素
    //   const topRange = 60;
    //   if (that._isInDingTalk() && (that.state.type === "dash" || that.state.type === "scenes") && that.state.isDashFull) {
    //     if (event.clientY <= topRange) {
    //       console.log('鼠标移入浏览器顶部');
    //       that.setState({
    //         isShowCloseTip: true
    //       })
    //     } else {
    //       that.setState({
    //         isShowCloseTip: false
    //       })
    //     }
    //   }

    // });
    window.addEventListener('keydown', function (event) {
      if ((that.state.type === "dash" || that.state.type === "scenes") && that._isInDingTalk() && event.key === 'Escape') {
        that.closeStateFullFn()
      }
    })
    setTimeout(() => {
      if (
        entryId !== "todo" &&
        entryId !== "create" &&
        entryId !== "transactors" &&
        entryId !== "cc" &&
        !BsyUtils.isObjectEmpty(this.props.entryMap)
      ) {
        if (!this.props.entryMap[entryId]) {
          tipAlert({
            type: "warning",
            msg: React.language("form.dash.empty"),
          });
          // console.log('form.dash.empty', appId, entryId, type)
          // this.setState({
          //   showContentEmpty: false,
          //   appId: appId,
          //   entryId: null,
          //   type: null,
          //   page: 0,
          // });
          // this.props.history.push(`${window.rootDirectroy}/team/app/${appId}`);
          return;
        }
      }

      window.$(".bsy-frame-menu").find(".select").removeClass("select");
      window.$("#menu" + entryId).addClass("select");
      if (
        window
          .$("#menu" + entryId)
          .parent()
          .parent()
          .prev().length > 0
      ) {
        window
          .$("#menu" + entryId)
          .parent()
          .parent()
          .parent()
          .find("ul").length > 0 &&
          window
            .$("#menu" + entryId)
            .parent()
            .parent()
            .parent()
            .find("ul")
            .show();
        window
          .$("#menu" + entryId)
          .parent()
          .parent()
          .parent()
          .find(".icon-bsy-folder-close")
          .addClass("icon-bsy-folder-open");
        window
          .$("#menu" + entryId)
          .parent()
          .parent()
          .parent()
          .find(".icon-bsy-folder-close")
          .removeClass("icon-bsy-folder-close");
      }

      this.loadFirst = true;
      if (type === "flow") {
        window.FX.STATIC.appId = appId;
        window.FX.STATIC.APPID = appId;
        that.show = true;
        //验证是否有相关数据，解决菜单栏会闪的问题
        React.axios(`/dashboard/app/${appId}/workflow/form_filter`, {
          appId: appId,
          ding: [],
          type: entryId,
        })
          .then((res) => {
            BsyUtils.showAjaxTip(res.data, () => {
              const data =
                entryId === "todo"
                  ? res.data.length
                    ? [...res.data]
                    : []
                  : res.data;
              this.setState(
                {
                  titleName:
                    this.FlowMenuData[entryId].text +
                    " - " +
                    this.props.appName,
                  filterList: data,
                  allFilterList: data,
                  showContentEmpty: data.length,
                },
                () => {
                  if (data.length)
                    this.loadContentByFlow(this.FlowMenuData[entryId], entryId);
                  else {
                    this.setState(
                      {
                        loadSuccess: true,
                      },
                      () => {
                        // document.querySelector(".header-flow") &&
                        //   document.querySelector(".header-flow").remove();
                      }
                    );
                  }
                  this.setEntryCache();
                }
              );
            });
          })
          .catch((res) => {
            console.error(res);
          });
      } else {
        if (!BsyUtils.isObjectEmpty(this.props.entryMap)) {
          window.FX.STATIC.appId = appId;
          window.FX.STATIC.entryId = entryId;
          window.FX.STATIC.APPID = appId;
          window.FX.STATIC.ENTRYID = entryId;
          this.loadFormDash(appId, entryId);
        } else {
          this.appId = null;
          this.entryId = null;
          this.setState({
            entryId: null,
            appId: null,
          });
        }
      }
    }, 30);
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //     if (
  //         BsyUtils.compare(this.props, nextProps) &&
  //         BsyUtils.compare(this.state, nextState)
  //     ) {
  //         return false;
  //     }
  //     return true;
  // }

  UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
    if (
      nextProps.appId === this.appId &&
      nextProps.entryId === this.entryId &&
      nextProps.type === this.type
    ) {
      return;
    }

    if (BsyUtils.isObjectEmpty(nextProps.entryMap)) {
      return;
    }

    this.appId = nextProps.appId;
    this.entryId = nextProps.entryId;
    this.type = nextProps.type;

    let nextPropsappId = nextProps.appId;
    let nextPropsentryId = nextProps.entryId;
    let nextPropstype = nextProps.type;

    if (
      [nextPropsentryId, nextPropsappId].join("@") !==
      [this.state.entryId, this.state.appId].join("@")
    ) {
      window.$(".bsy-frame-menu").find(".select").removeClass("select");
      window.$("#menu" + nextPropsentryId).addClass("select");

      if (
        !nextProps.entryMap[nextPropsentryId] &&
        nextPropsentryId !== "todo" &&
        nextPropsentryId !== "create" &&
        nextPropsentryId !== "transactors" &&
        nextPropsentryId !== "cc"
      ) {
        tipAlert({
          type: "warning",
          msg: React.language("form.dash.empty"),
        });

        this.setState({
          showContentEmpty: false,
          appId: nextPropsappId,
          entryId: null,
          type: null,
          page: 0,
          isAllSelectBatch: 0,
          isBatchForward: false,
          batchForwardList: [],
          appType: nextProps.appType,
          editAuth: nextProps.editAuth,
        });
        this.props.history.push(
          `${window.rootDirectroy}/team/app/${nextPropsappId}`
        );
        return;
      }

      if (nextPropstype === "flow") {
        window.FX.STATIC.appId = nextPropsappId;
        window.FX.STATIC.APPID = nextPropsappId;
        this.show = true;
        //验证是否有相关数据，解决菜单栏会闪的问题
        React.axios(`/dashboard/app/${nextPropsappId}/workflow/form_filter`, {
          appId: nextPropsappId,
          ding: [],
          type: nextPropsentryId,
        })
          .then((res) => {
            BsyUtils.showAjaxTip(res.data, () => {
              const data =
                nextPropsentryId === "todo"
                  ? res.data.length
                    ? [...res.data]
                    : []
                  : res.data;
              this.setState({
                appId: nextPropsappId,
                entryId: nextPropsentryId,
                type: nextPropstype,
                isAllSelectBatch: 0,
                isBatchForward: false,
                batchForwardList: [],
                search: "",
                filterList: [],
                allFilterList: data,
                titleName:
                  (this.FlowMenuData[nextPropsentryId]?.text || "") +
                  " - " +
                  this.props.appName,
                showContentEmpty: data.length,
                showFilter: false,
                page: 0,
              }, () => {
                if (this.FlowMenuData[nextPropsentryId] && data.length)
                  this.loadContentByFlow(
                    this.FlowMenuData[nextPropsentryId],
                    nextPropsentryId
                  );
                else {
                  this.setState(
                    {
                      loadSuccess: true,
                    },
                    () => {
                      // document.querySelector(".header-flow") &&
                      //   document.querySelector(".header-flow").remove();
                      document.querySelector(".form-view") &&
                        document.querySelector(".form-view").remove();
                    }
                  );
                }
                this.setEntryCache();
              }
              );
            });
          })
          .catch((res) => {
            console.error(res);
          });
      } else {
        window.FX.STATIC.appId = nextPropsappId;
        window.FX.STATIC.entryId = nextPropsentryId;
        window.FX.STATIC.APPID = nextPropsappId;
        window.FX.STATIC.ENTRYID = nextPropsentryId;
        window.FX.STATIC.DATAID = null;
        this.loadFormDash(nextPropsappId, nextPropsentryId);
      }
    }
  }
  closeDashFull = () => {
    this.closeStateFullFn()
  }
  closeStateFullFn = () => {
    let that = this
    let fullEl = BsyUtils.closestClass(
      that.dashContent.current,
      "bsy-frame-content"
    );
    window.$('.bsy-frame-content').css("right", "150px")
    fullEl.classList.remove("fullScreen");
    fullEl.classList.remove("dash-theme-dark");
    BsyUtils.exitFullscreen()
    window.dashSetInterval && clearInterval(window.dashSetInterval);
    that.setState(
      {
        isDashFull: false,
      },
      () => {
        setTimeout(() => {
          that.bsyDashContext && that.bsyDashContext.doResize()
        }, 400);
      }
    );
  }
  _loadContentByAgainAdd = (b, n) => {
    let c = this;
    window.FX.Utils.dataAjax(
      {
        url: "/dashboard/app/" + b.appId + "/entry/" + b.entryId,
      },
      function (f) {
        window.FX.STATIC.IS_EVENT = f.entry.isEvent === true;
        window.FX.STATIC.isSubmit = f.entry.content
          ? f.entry.content.isSubmit
          : "no";
        c._createFormView(f.entry, n);
      }
    );
  };

  //设置工作台最后一次访问的页面
  setEntryCache = () => {
    const { appId, entryId, type } = this.state;
    let key = "_appID_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
    let contText = BsyUtils.Store.get(key) || {};
    contText[window.FX.STATIC.corpId] = {
      ...contText[window.FX.STATIC.corpId],
      [appId]: {
        appid: appId,
        entryid: entryId,
        type: type,
      },
      selectAppid: appId,
      user_id: window.FX.STATIC["user"]._id,
    };
    BsyUtils.Store.set(key, contText);
  };

  _createFormView = (b, authGroupId) => {
    let c = this;
    window.FX.STATIC.IS_EVENT = b.isEvent === true;
    window.FX.STATIC.entryId = b.entryId;
    window.FX.STATIC.ENTRYID = b.entryId;
    new window.FX.Form(
      window.$.extend(b.content, {
        renderEl: window
          .$("<div/>")
          .appendTo(window.$(c.content.current).empty()),
        appId: b.appId,
        entryId: b.entryId,
        width: "100%",
        enableRowEdit: b.enableRowEdit,
        authGroupId: authGroupId,
        hasHeader: !1,
        is_dock_form: c.state.is_dock_form,
        hasFlow: b.hasFlow && !b.hasCoop,
        hasFlowPrint: b.hasFlowPrint,
        multiTabs: b.formTabs,
        formTabsStyle: b.formTabsStyle || {},
        flows: b.flow,
        isEvent: b.isEvent,
        height: "100%",
        submitText: React.language("submit"),
        hasFooter: b.content
          ? b.content.isSubmit
            ? b.content.isSubmit === "yes"
              ? !0
              : !1
            : !0
          : !0,
        printText: b.hasFlowPrint ? b.flow.print_text : null,
        buttonPosition: "left",
        onSuccess: function (a, d, e) {
          if (a.error_code) {
            let title = React.language("form.submit.fail.charger");
            let msg = React.language("form.submit.fail.charger.desc");
            if (
              a.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.FORWARD_COND
            ) {
              title = React.language("form.submit.fail.cond");
              msg = React.language("form.submit.fail.cond.desc");
            } else if (
              a.error_code === BsyConfig().CONST.FLOW_FAIL_CODE.approval
            ) {
              title = React.language("form.submit.fail.approval");
              msg = React.language("form.submit.fail.approval.desc");
            }
            c._createFormView(b, authGroupId); //2023 10 16 波波 修复 子表单id重复的问题
            BsyAlert({
              title: title,
              msg: msg,
              type: "warning",
              text4Cancel: null,
              text4Ok: React.language("iSee"),
            });
            return;
          }
          a.flowAction = d;

          if (e) {
            window.FX.Utils._showFormPrint(a.data);
            window.$(c.content.current).empty();
            window.FX.Utils.showSuccessInfo(
              window.$(c.content.current),
              a,
              function () {
                window.FX.STATIC.IS_EVENT
                  ? c._loadContentByAgainAdd(b, authGroupId)
                  : c._createFormView(b, authGroupId);
              }
            );
          } else {
            if (window.FX.Utils.hasHref()) {
              let hasBlank = window.FX.STATIC.FORMHREF.hasBlank;
              let data = window.$.extend(true, {}, arguments[3], a.retdata);
              data._id = {
                data: a.dataId,
              };
              window.FX.Utils.href(data);
              if (hasBlank) {
                window.$(c.content.current).empty();
                window.FX.Utils.showSuccessInfo(
                  window.$(c.content.current),
                  a,
                  function () {
                    window.FX.STATIC.IS_EVENT
                      ? c._loadContentByAgainAdd(b, authGroupId)
                      : c._createFormView(b, authGroupId);
                  }
                );
              }
            } else {
              window.$(c.content.current).empty();
              window.FX.Utils.showSuccessInfo(
                window.$(c.content.current),
                a,
                function () {
                  window.FX.STATIC.IS_EVENT
                    ? c._loadContentByAgainAdd(b, authGroupId)
                    : c._createFormView(b, authGroupId);
                }
              );
            }
          }
        },
        onError: function (a) {
          window.$(c.content.current).empty();
          window.FX.Utils.showErrorInfo(
            window.$(c.content.current),
            a,
            function () {
              window.FX.STATIC.IS_EVENT
                ? c._loadContentByAgainAdd(b, authGroupId)
                : c._createFormView(b, authGroupId);
            }
          );
        },
      })
    );
  };

  queryCcUnread = () => {
    // React.axios('/data/query_cc_unread', {
    //     appId,
    //     entryId: formId,
    //     formId: formId,
    // }).then(res => {
    //     if (res.data) {
    //         if (res.data.exist_cc_unread) {
    //             document.getElementById('menucc') && document.getElementById('menucc').classList.add('unread')
    //             document.querySelector('.todoMenu-item.isread0') && document.querySelector('.todoMenu-item.isread0').classList.add('unread')
    //         } else {
    //             document.getElementById('menucc') && document.getElementById('menucc').classList.remove('unread')
    //             document.querySelector('.todoMenu-item.isread0') && document.querySelector('.todoMenu-item.isread0').classList.remove('unread')
    //         }
    //     }
    // }).catch(res => {
    // })
  };

  _createFormViewSelector = (b, c) => {
    window.FX.STATIC.isSubmit = b.content.isSubmit;
    if (window.FX.Utils.isObjectEmpty(c)) {
      return [];
    }
    // return void this._createFormView(b);
    let e = {},
      f = [];
    BsyUtils.forEach(c, function (a, b) {
      b.groupId >= 0 &&
        f.push({
          text: b.name,
          value: b.groupId,
          customCls: b.groupId === 0 ? "all-permission" : undefined,
        });
      e[b.groupId] = b;
    });
    let g = [],
      h = {
        "-1": React.language("auth.group.submit.name"),
        "-4": React.language("auth.group.manage.name"),
        "-3": React.language("auth.group.manageOwn.name"),
        "-2": React.language("auth.group.review.name"),
      };
    if (!b.hasCoop) {
      h = {
        "-1": React.language("flow.launch"),
        "-4": React.language("flow.auth.group.manage.name"),
        "-2": React.language("flow.auth.group.review.name"),
      };
    }
    BsyUtils.forEach(h, function (a, b) {
      let c = e[a];
      c &&
        g.push({
          text: b,
          value: c.groupId,
        });
    });
    f = g.concat(f);
    let i = f[0].value;
    let j = BsyUtils.Store.getKey("authGroup", {
      appId: b.appId,
      entryId: b.entryId,
    });
    let k = BsyUtils.Store.get(j);
    if (!BsyUtils.isNull(k)) {
      e[k] ? (i = k) : BsyUtils.Store.remove(j);

      if (f.length > 0) {
        const bb = f.map((d) => {
          d.selected = false;
          if (d.value === i) d.selected = true;
          return d;
        });
        f = bb;
      }
    }
    if (f.length === 1) {
      if (f[0].value === -1) {
        return {
          formAuthGroups: [],
          authGroupMap: e,
          authGroupId: i,
        };
      }
    }
    return {
      formAuthGroups: f,
      authGroupMap: e,
      authGroupId: i,
    };
  };

  _setFormView = (b, c, d) => {
    let e = this;
    switch (b) {
      case -1:
        e._createFormView(d, b);
        break;
      default:
        let f = c[b];
        if (!f) return;
        let showFields = [];
        window.$.map(f.optAuth, function (v, k) {
          if (v.visible) showFields.push(k);
        });
        let g = BsyUtils.Store.getKey("paramFields", {
          appId: window.FX.STATIC.appId,
          entryId: d.entryId,
          groupId: b,
        }),
          h = BsyUtils.Store.getKey("showFields", {
            appId: window.FX.STATIC.appId,
            entryId: d.entryId,
            groupId: b,
          }),
          i = BsyUtils.Store.getKey("metaFields", {
            appId: window.FX.STATIC.appId,
            entryId: d.entryId,
            groupId: b,
          });
        window.FX.STATIC.DECISION_SWITCH =
          d.flow && d.flow.decision && d.flow.decision.switch
            ? d.flow.decision.switch
            : false;
        new window.FX.DataManagePane({
          renderEl: window
            .$("<div/>")
            .appendTo(window.$(this.content.current).empty()),
          appId: d.appId,
          entryId: d.entryId,
          formName: d.name,
          formTabs: d.formTabs,
          formTabsStyle: d.formTabsStyle || {},
          formItems: d.content.items,
          submitAttr: d.content.submitAttr,
          data_cache: d.content.data_cache,
          initializeModuleEvent: d.content.initializeModuleEvent,
          initializeDataExtendSet: d.content.initializeDataExtendSet,
          formAttr: {
            submitRule: d.content.submitRule,
            layout: d.content.layout,
            validators: d.content.validators,
            confirmSettings: d.content.confirmSettings,
            fieldShowRules: d.content.fieldShowRules,
            subformFieldShowRules: d.content.subformFieldShowRules,
          },
          originPrint: "group",
          hasExtParams: d.hasExtParams,
          hasUserSource: d.hasUserSource === true,
          hasFlow: d.hasFlow,
          hasCoop: d.hasCoop,
          flow: d.flow,
          dataPerms: f.dataPerms,
          optAuth: f.optAuth,
          authGroupId: b,
          showFieldsFilter: BsyUtils.Store.get(g),
          showFields: BsyUtils.Store.get(h),
          showFieldsMeta: BsyUtils.Store.get(i),
          printId: f.printId,
          is_dock_form: e.state.is_dock_form,
          onParamFieldSelect: function (a) {
            BsyUtils.Store.set(g, a);
          },
          onDataFieldSelect: function (a) {
            BsyUtils.Store.set(h, a);
          },
          onDataFieldMetaChange: function (a) {
            BsyUtils.Store.set(i, a);
          },
        });
    }
  };

  loadFormDash = (id, entryId) => {
    const { isDashFull } = this.state;
    const $ = window.$;
    const FX = window.FX;
    const c = this;

    React.axios(
      `/dashboard/app/${id}/entry/${entryId}`,
      { appId: id },
      { cancelTokenTs: this.cancelTokenTs }
    ).then((res) => {
      const AllH = res ? res.data : {};
      const h = res ? res.data.entry : {};
      BsyUtils.forEach(h.components, (key, value) => {
        if (BsyUtils.isObjectEmpty(value)) {
          delete h.components[key];
        }
      });
      const t = h.type;
      FX.STATIC.appId = id;
      FX.STATIC.entryId = entryId;

      // 多层弹表单的时候需要使用
      window.GLOBALAPPID = id;
      window.GLOBALENTRYID = entryId;

      window.FX.STATIC.INNERLINK = h._id;
      let ids = res.data.dock_current_departments;
      for (let index = 0; index < ids.length; index++) {
        const element = ids[index];
        let sid = element._id || element.id;
        window.deptSelectMap[sid] = element;
      }
      ids = res.data.dock_current_sub_departments;
      for (let index = 0; index < ids.length; index++) {
        const element = ids[index];
        let sid = element._id || element.id;
        window.deptSelectMap[sid] = element;
      }
      window.localDevInfo.user.dock_current_departments =
        res.data.dock_current_departments;
      window.localDevInfo.user.dock_current_sub_departments =
        res.data.dock_current_sub_departments;
      if (!BsyUtils.isObjectEmpty(h.href)) {
        FX.STATIC.FORMHREF = h.href;
      } else {
        FX.STATIC.FORMHREF = null;
      }
      if (h) {
        if (t === "form") {
          let groups = this._createFormViewSelector(h, res.data.authGroups);

          window.FX.STATIC.PublicData = h.PublicData || {
            isPublicData: !1,
          };
          c.setState(
            {
              isLoading: false,
              entryname: h.name,
              type: t,
              showContentEmpty: true,
              page: 0,
              appId: id,
              entryId: entryId,
              formAuthGroups: groups.formAuthGroups,
              authGroupId: groups.authGroupId,
              authGroupMap: groups.authGroupMap,
              is_dock_form: res.data.is_dock_form,
              titleName:
                this.props.entryMap[entryId].name + " - " + this.props.appName,
              formConfig: {
                ...h,
                is_dock_form: res.data.is_dock_form,
                appId: h.appId,
                entryId: h.entryId,
              },
            },
            () => {
              this.setEntryCache();
              this._createPath(h);
              // if (BsyUtils.isObjectEmpty(groups.authGroupId)) {
              //     this._createFormView(h)
              // } else {
              //     groups.authGroupId === -1 && this._setFormView(groups.authGroupId, groups.authGroupMap, h)
              // }
              // else {
              //     this._setFormView(groups.authGroupId, groups.authGroupMap, h);
              // }
            }
          );
        } else if ("report" === t) {
          c.setState(
            {
              isLoading: false,
              type: t,
              entryname: h.name,
              showContentEmpty: true,
              appId: id,
              is_dock_form: res.data.is_dock_form,
              showFilter: false,
              entryId: entryId,
              page: 0,
              titleName:
                this.props.entryMap[entryId].name + " - " + this.props.appName,
            },
            () => {
              this.setEntryCache();
              this._createPath(h);
              let i = h.content;
              this.Report = new FX.Report(
                $.extend(i, {
                  renderEl: $("<div/>").appendTo($(this.content.current)),
                  appId: id,
                  entryId: entryId,
                  width: "100%",
                  height: "100%",
                  hasLazyLoad: !0,
                })
              );
            }
          );
        } else if ("dash" === t || "scenes" === t) {
          let d = document.getElementById("dash-custom-style");
          if (d) {
            d.remove();
          }

          this.rel = h.rel || "and";
          //为什么在这里清空呢，因为组件pros传值可能会造成 cacheFilter 丢失的情况 ？？？ 莫名其妙 找到新方案后再解决
          if (!h.cacheFilter) {
            //清空缓存，筛选条件模式的默认值与缓存值不一致的情况
            let key = `dashFilterCache${h.appId}${h.entryId}`;
            if (BsyUtils.Store.has(key)) {
              BsyUtils.Store.remove(key);
            }
          } else {
            let key = `dashFilterCache${h.appId}${h.entryId}`;
            let filter = BsyUtils.Store.get(key);
            // console.log(key)
            // console.log(filter)
            if (filter && filter.rel) {
              this.rel = filter.rel;
            }
          }
          BsyUtils._getDashRequest(h);

          c.setState(
            {
              isLoading: false,
              entryname: h.name,
              type: t,
              showContentEmpty: true,
              page: 0,
              appId: id,
              entryId: entryId,
              is_dock_form: res.data.is_dock_form,
              titleName:
                this.props.entryMap[entryId].name + " - " + this.props.appName,
              dashConfig: {
                ...h,
                is_dock_form: res.data.is_dock_form,
                appId: h.appId,
                entryId: h.entryId,
                hasLazyLoad: !0,
              },
              allComponentDash: {
                ...AllH,
                is_dock_form: res.data.is_dock_form,
                appId: h.appId,
                entryId: h.entryId,
                hasLazyLoad: !0,
              },
            },
            () => {
              this.setEntryCache();
            }
          );
        }
      }
    });
  };

  _createReportFull = (cb) => {
    let fv = window
      .$('<div class="form-view Full"></div>')
      .css({
        left: "auto",
        right: this.props && this.state.editAuth ? "122px" : "26px",
      })
      .on("click", function () {
        cb && cb();
      })
      .appendTo(window.$(this.path.current).children(".breadcrumb"));
    window.$("<i />").addClass("icon-bsy-iconquanping").appendTo(fv);
    window.$("<span>").text(React.language("fullScreen")).appendTo(fv);
  };

  removeFilterList = (r) => {
    return (event) => {
      event.preventDefault();
      event.stopPropagation();
      const { filterList } = this.state;
      let selectList = this.getFlowDingList("select").filter((it) => it);

      if (selectList.length <= 0) {
        selectList.push(filterList[0].entryId);
      }
      if (filterList.length <= 1) {
        tipAlert({
          type: "warning",
          msg: React.language("flow.min.len", { num: 1 }),
        });
        return;
      }
      filterList.map((res, key) => {
        if (r.entryId === res.entryId) {
          if (selectList[0] === r.entryId) {
            if (key === 0) {
              this.setFlowDingList([filterList[key + 1].entryId], "select");
            } else if (key === filterList.length - 1) {
              this.setFlowDingList(
                [filterList[filterList.length - 2].entryId],
                "select"
              );
            } else {
              this.setFlowDingList([filterList[key - 1].entryId], "select");
            }
          }
          filterList.splice(key, 1);
        }
      });
      this.setState(
        {
          filterList,
        },
        () => {
          let dingList = this.getFlowDingList("ding");
          if (dingList.indexOf(r.entryId) > -1) {
            dingList.splice(dingList.indexOf(r.entryId), 1);
          } else {
            dingList.push(r.entryId);
          }
          this.setFlowDingList(dingList, "ding");
          this.setFlowDingList(filterList, "filter");
          this.reFilterList("remove");
        }
      );
    };
  };

  scrollFunc = (e) => {
    // let page = this.state.page
    // const scrollTop = this.content.current.scrollTop;
    // const clientHeight = this.content.current.clientHeight;
    // const scrollHeight = this.content.current.scrollHeight;
    // //滚动条位置为0的时候 不能触发数据加载
    // if (scrollTop > 0 && (scrollTop + clientHeight + 10) >= scrollHeight) {
    //     page++
    //     this.setState({
    //         page,
    //     }, () => {
    //         this.scrollLoad()
    //     })
    // }
    const { isMore, page } = this.state;

    if (isMore) {
      if (this.flowContent && this.flowContent.current) {
        if (
          this.flowContent.current.offsetHeight <=
          e.target.scrollTop + e.target.offsetHeight
        ) {
          this.setState(
            {
              isMore: false,
              page: page + 1,
            },
            () => {
              // this.loadData('more')
              this.scrollLoad();
            }
          );
        }
      }
    }
  };

  reFilterList = (f, ref) => {
    let flowStoreList = []; //this.getFlowDingList("ding");
    let selectList = this.getFlowDingList("select").filter((it) => it);
    const { allFilterList } = this.state;
    let dingLists = {};
    let filterList = this.getFlowDingList("filter").filter((it) => it);
    let selectForm = {};
    let showAllFilter = true;
    // let showAllFilter = allFilterList.length > filterList.length;
    // if (filterList.length === 0) {
    //     showAllFilter = false;
    // }
    let hasForm = false;

    //检测 ding的数据
    let dings = [];
    let filterList1 = [];

    //检测 ding的数据

    allFilterList.map((res) => {
      filterList1.push(res.entryId);
      filterList.map((res1, key1) => {
        if (res.entryId === res1.entryId) {
          filterList[key1] = res;
        }
      });
    });
    let newFilterList = [];
    let newFilterlistMap = {};
    filterList.map((res1) => {
      // if (flowStoreList.indexOf(res1.entryId) > -1) {
      //     dings.push(res1.entryId)
      // }
      if (filterList1.indexOf(res1.entryId) > -1) {
        newFilterList.push(res1);
        newFilterlistMap[res1.entryId] = res1;
      }
    });
    flowStoreList = dings;
    this.setFlowDingList(flowStoreList, "ding");
    if (f !== "remove" && f !== "click") {
      // 先补全所有数据
      allFilterList.map((res) => {
        if (!newFilterlistMap[res.entryId]) {
          newFilterList.push(res);
        }
      });
    }

    this.setState(
      {
        filterList: newFilterList,
        page: 0,
        scrollDataLength: 0,
      },
      () => {
        const ELWidth =
          this.getStyle(this.path.current, "width") -
          this.getStyle(this.breadcrumb.current, "width") -
          183;
        let iWidth = 0;
        let filterList = this.state.filterList;
        let allLeng = allFilterList.length;
        let filterArray = [];
        for (
          let i = 0;
          i < this.path.current.getElementsByClassName("header-itme").length;
          i++
        ) {
          iWidth +=
            this.getStyle(
              this.path.current.getElementsByClassName("header-itme")[i],
              "width"
            ) + 10;
        }
        for (
          let i =
            this.path.current.getElementsByClassName("header-itme").length - 1;
          i >= 0;
          i--
        ) {
          if (iWidth >= ELWidth) {
            let w = this.getStyle(
              this.path.current.getElementsByClassName("header-itme")[i],
              "width"
            );
            filterList.splice(i, 1);
            allLeng--;
            iWidth -= w;
          }
        }

        let allFilterIdList = [];

        if (filterList.length <= 0) {
          allFilterIdList = [];
          allFilterList.map((res, key) => {
            res.selected = false;
            allFilterIdList.push(res.entryId || res.appId);
            if (selectList.length <= 0 && key === 0) {
              if (this.state.entryId !== "todo") {
                selectForm = res;
                res.selected = true;
              }
            }
            if (selectList.indexOf(res.entryId || res.appId) > -1) {
              selectForm = res;
              res.selected = true;
            }
            if (flowStoreList.indexOf(res.entryId) > -1) {
              res.dinged = true;
              dingLists[key] = res;
              filterList.push(res);
            } else {
              res.dinged = false;
              filterList.push(res);
            }
          });
        } else {
          allFilterIdList = [];
          allFilterList.map((res, key) => {
            res.selected = false;
            allFilterIdList.push(res.entryId || res.appId);
            if (selectList.length <= 0 && key === 0) {
              if (this.state.entryId !== "todo") {
                res.selected = true;
                selectForm = res;
              }
            }
            if (selectList.indexOf(res.entryId || res.appId) > -1) {
              selectForm = res;
              res.selected = true;
            }
            if (flowStoreList.indexOf(res.entryId) > -1) {
              res.dinged = true;
              dingLists[key] = res;
            } else {
              res.dinged = false;
            }
            return null;
          });
          filterList.map((res, key) => {
            res.selected = false;
            if (selectList.length <= 0 && key === 0) {
              if (this.state.entryId !== "todo") {
                selectForm = res;
                res.selected = true;
              }
            }
            if (selectList.indexOf(res.entryId || res.appId) > -1) {
              selectForm = res;
              res.selected = true;
            }
            if (flowStoreList.indexOf(res.entryId) > -1) {
              res.dinged = true;
              dingLists[key] = res;
            } else {
              res.dinged = false;
            }
            return null;
          });
        }
        if (selectList.length > 0) {
          selectList.map((res) => {
            if (allFilterIdList.indexOf(res) < 0) {
              if (filterList.length <= 0) {
                if (this.state.entryId !== "todo") {
                  selectForm = allFilterList[0];
                  allFilterList[0].selected = true;
                }
              } else {
                if (this.state.entryId !== "todo") {
                  selectForm = filterList[0];
                  filterList[0].selected = true;
                }
              }
            }
            return null;
          });
        }

        if (selectForm.entryId) {
          filterList.map((res) => {
            if (res.entryId === selectForm.entryId) {
              hasForm = true;
            }
            return null;
          });
          let hasDing = [];
          let newForm = [];
          let newForm1 = [];
          if (!hasForm) {
            BsyUtils.forEach(newForm, () => {
              newForm1.push(selectForm);
            });
            filterList.map((res, key) => {
              if (res.dinged) {
                hasDing[key] = res;
                newForm[key] = null;
              } else {
                newForm[key] = res;
                hasDing[key] = null;
              }
              return null;
            });

            newForm.unshift(selectForm);
            let f = 0;
            if (iWidth <= ELWidth - 310) {
              hasDing[hasDing.length] = null;
            }
            hasDing.map((res, key) => {
              if (!res) {
                while (!newForm[key + f]) {
                  f--;
                }

                hasDing[key] = newForm[key + f];
                if (newForm[key + f]) {
                  f = 0;
                }
              }
              return null;
            });
            if (newForm.length > hasDing.length) {
              let newFilterList = [];
              let isAllDing = true;
              hasDing.map((res, key) => {
                if (!res.dinged) {
                  isAllDing = false;
                }
                if (key === 0) {
                  newFilterList[0] = newForm[0];
                } else {
                  newFilterList.push(hasDing[key - 1]);
                }
                return null;
              });
              if (isAllDing) {
                filterList = newFilterList;
              } else {
                filterList = hasDing;
              }
            } else {
              filterList = hasDing;
            }
          }
        }

        filterList.map((res) => {
          filterArray.push(res.entryId);
          return null;
        });

        if (f === "click" && ref) {
          let forms = filterList.shift();
          filterList.push(forms);
        }

        f !== "click" && this.loadFormFlow(selectForm);

        this.setState(
          {
            filterList,
            selectForm,
          },
          () => {
            let filterList = this.state.filterList;
            // this.content.current.removeEventListener("scroll", this.scrollFunc);
            // this.content.current.addEventListener("scroll", this.scrollFunc);
            const ELWidth =
              this.getStyle(this.path.current, "width") -
              this.getStyle(this.breadcrumb.current, "width") -
              183;
            let iWidth = 0;
            for (
              let i = 0;
              i <
              this.path.current.getElementsByClassName("header-itme").length;
              i++
            ) {
              iWidth +=
                this.getStyle(
                  this.path.current.getElementsByClassName("header-itme")[i],
                  "width"
                ) + 10;
            }
            for (
              let i =
                this.path.current.getElementsByClassName("header-itme").length -
                1;
              i >= 0;
              i--
            ) {
              if (iWidth >= ELWidth) {
                let w = this.getStyle(
                  this.path.current.getElementsByClassName("header-itme")[i],
                  "width"
                );
                filterList.splice(i, 1);
                allLeng--;
                iWidth -= w;
              }
            }
            this.setState(
              {
                filterList,
                showAllFilter,
              },
              () => {
                let filterList = this.state.filterList;
                this.setFlowDingList(filterList, "filter");
              }
            );
          }
        );
      }
    );
  };

  loadContentByFlow = () => {
    this.reFilterList();
  };

  getStyle = (el, s) => {
    if (!el) {
      return 0;
    }
    let attr = window.getComputedStyle(el)[s];
    if (s === "width") {
      attr = parseFloat(attr.split("px")[0]);
    }
    return attr;
  };

  setFlowDingList = (v, k) => {
    const { appId, entryId, type } = this.state;
    let key = [k, appId, entryId, type].join("@");
    BsyUtils.Store.set(key, v);
  };

  getFlowDingList = (k) => {
    const { appId, entryId, type } = this.state;
    let key = [k, appId, entryId, type].join("@");
    return BsyUtils.Store.get(key) || [];
  };

  _createPath = (b) => {
    let $ = window.$;
    // $(this.entryname.current).removeClass();
    // $(this.entryname.current).addClass("entry-name");
    // $(this.entryname.current).addClass(b.type);
    if (this.entryname.current) $(this.entryname.current).text(b.name);
    if (this.path.current) {
      $(this.breadcrumb.current).show();
      $(this.path.current).removeAttr("style");
      $(this.path.current).show();
      $(this.content.current).parent().parent().removeAttr("style");
      $(this.path.current).find(".form-view").remove();
      $(this.path.current).find(".header-flow").remove();
      $(".data-config-btn.filter-btn", $(this.path.current)).remove();
      if (b.type === "flow") {
        $(this.path.current).css("border-radius", "10px");
        $(this.path.current.getElementsByClassName("edit-form")[0]).hide();
        $(this.path.current.parentNode.parentNode).css("box-shadow", "none");
      } else {
        // $(this.path.current).css("border-radius", "10px 10px 0 0")
        $(this.path.current.getElementsByClassName("edit-form")[0]).show();
        $(this.path.current.parentNode.parentNode).css(
          "box-shadow",
          "0 0 10px 0 rgba(0, 0, 0, 0.02)"
        );
      }
    }
  };

  toEditForm = () => {
    const { appId, entryId, type } = this.state;
    if (entryId)
      window.location.href = `${window.rootDirectroy}/dashboard/app/${appId}/${type}/${entryId}/edit`;
    else
      window.location.href =
        window.rootDirectroy +
        "/dashboard" +
        window.location.pathname.split("/team")[1] +
        "/edit";
  };

  onfullscreenchange = () => {
    const { type } = this.state;
    let that = this;

    if (this.setTimeoutHandle) {
      clearTimeout(this.setTimeoutHandle);
      this.setTimeoutHandle = null;
    }

    this.setTimeoutHandle = setTimeout(() => {
      if (type == "dash" || type == "scenes") {
        that.bsyDashContext &&
          that.bsyDashContext.doResize &&
          that.bsyDashContext.doResize();
        that.bsyDashContext &&
          that.bsyDashContext._dealFilter &&
          that.bsyDashContext._dealFilter();
      }
      this.setTimeoutHandle = null;
    }, 200);
  };

  updateTime = [];

  onFullDash = () => {
    let { dashConfig } = this.state;
    // if (dashConfig.components && !JSON.stringify(dashConfig) !== "{}") {
    //   var cddashConfig = Object.fromEntries(Object.entries(dashConfig.components).filter(([key1, val]) => {
    //     return !val['parentsId']
    //   }))
    //   dashConfig.components = cddashConfig
    // }
    let fullEl = BsyUtils.closestClass(
      this.dashContent.current,
      "bsy-frame-content"
    );
    if (fullEl) {
      if (fullEl.classList.contains("fullScreen")) {
        fullEl.classList.remove("fullScreen");
        fullEl.classList.remove("dash-theme-dark");

        // BsyUtils.exitFullscreen();
        window.dashSetInterval && clearInterval(window.dashSetInterval);
        this.setState(
          {
            isDashFull: false,
          },
          () => {
            this.bsyDashContext && this.bsyDashContext.doResize();
          }
        );
      } else {
        fullEl.classList.add("fullScreen");
        if (
          dashConfig.styles &&
          dashConfig.styles.theme.name != "preset_style_light_1"
        ) {
          fullEl.classList.add("dash-theme-dark");
        }
        BsyUtils.requestFullScreen(() => {
          this.onFullDash();
        });

        this.setState(
          {
            isDashFull: true,
          },
          () => {
            setTimeout(() => {
              this.bsyDashContext && this.bsyDashContext.doResize()
            }, 200);
            this.autoRefresh();
          }
        );
      }
    }
  };
  _isInDingTalk = () => {
    return /DingTalk/i.test(navigator.userAgent);
  }
  autoRefresh = () => {
    let { dashConfig, allComponentDash } = this.state;
    // if (dashConfig.components && !JSON.stringify(dashConfig) !== "{}") {
    //   var cddashConfig = Object.fromEntries(Object.entries(dashConfig.components).filter(([key1, val]) => {
    //     return !val['parentsId']
    //   }))
    //   dashConfig.components = cddashConfig
    // }
    if (dashConfig.autoRefresh && dashConfig.autoRefresh.enabled) {
      const appId = dashConfig.appId;
      let data = [];
      let formIdList = [];
      //缓存所有表单ID 用于后续判断 刷新的逻辑
      BsyUtils.forEach(allComponentDash.entry.components, (key, val) => {
        if (!val) {
          return;
        }
        if (!val.forms) {
          return;
        }
        if (!val.forms[0]) {
          return;
        }
        if (formIdList.indexOf(val.forms[0]) < 0) {
          if (val.forms[0].indexOf("@") > -1) {
            data.push({
              appId: val.forms[0].split("@")[1],
              formId: val.forms[0].split("@")[0],
            });
          } else {
            data.push({
              appId,
              formId: val.forms[0],
            });
          }
          formIdList.push(val.forms[0]);
        }
      });
      let timeNum = this.state.dashConfig.autoRefresh.autoRefreshTime;
      if (this.state.dashConfig.autoRefresh.autoRefreshTime === "custom") {
        timeNum = this.state.dashConfig.autoRefresh.autoRefreshTimeNum;
      }
      React.axios("/data/get_update_time", data)
        .then((res) => {
          this.updateTime = res.data;
          this.bsyDashContext &&
            this.bsyDashContext._dealFilter &&
            this.bsyDashContext._dealFilter();
          window.dashSetInterval = setInterval(() => {
            React.axios("/data/get_update_time", data)
              .then((res) => {
                let flg = false;
                for (let i = 0; i < res.data.length; i++) {
                  if (
                    res.data[i].updateTime !== this.updateTime[i].updateTime
                  ) {
                    flg = true;
                    this.bsyDashContext &&
                      this.bsyDashContext._dealFilter &&
                      this.bsyDashContext._dealFilter(
                        false,
                        "isFull",
                        res.data[i]
                      );
                  }
                }
                if (flg) {
                  this.updateTime = res.data;
                  if (window.dashSetInterval) {
                    clearInterval(window.dashSetInterval);
                    window.dashSetInterval = null;
                  }
                }
              })
              .catch((res) => {
                console.log(res);
              });
          }, timeNum * 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    }
  };

  switchSortTime = (v, ref) => {
    return () => {
      const { selectForm } = this.state;
      if (ref) {
        ref.closeAlter && ref.closeAlter();
      }
      this.setState(
        {
          updateTime: v,
        },
        () => {
          this.loadFormFlow(selectForm);
        }
      );
    };
  };

  sortTime = (event) => {
    const { updateTime, entryId } = this.state;

    // const { sort, type } = this.state;
    let menu = [
      {
        text: React.language("platform.flow." + entryId + ".latest"),
        colorType: updateTime === -1 ? "selected" : "",
        icon: updateTime === -1 ? "icon-ok" : "",
        click: this.switchSortTime(-1, null),
      },
      {
        text: React.language("platform.flow." + entryId + ".earliest"),
        colorType: updateTime === 1 ? "selected" : "",
        icon: updateTime === 1 ? "icon-ok" : "",
        click: this.switchSortTime(1, null),
      },
    ];

    BsyAlertMenu({
      item: menu,
      width: 140,
      target: event.currentTarget,
      theme: "flow-sort",
    });

    // BsyMsgBubble({
    //   anchor: event.currentTarget,
    //   contentHTML: (ref) => {
    //     return (
    //       <div className="sortTime"
    //         style={{
    //           margin: 4,
    //         }}
    //       >
    //         <ul className="menu-pane">
    //           <li
    //             className={"menu-item " + (updateTime === -1 ? "selected" : "")}
    //             onClick={this.switchSortTime(-1, ref)}
    //           >
    //             <span>{React.language("platform.flow.todo.latest")}</span>
    //             {updateTime === -1 && <i className="icon-ok"></i>}
    //           </li>
    //           <li
    //             className={"menu-item " + (updateTime === 1 ? "selected" : "")}
    //             onClick={this.switchSortTime(1, ref)}
    //           >
    //             <span>{React.language("platform.flow.todo.earliest")}</span>
    //             {updateTime === 1 && <i className="icon-ok"></i>}
    //           </li>
    //         </ul>
    //       </div>
    //     );
    //   },
    //   text4Cancel: null,
    //   text4Ok: null,
    //   contentPadding: 0,
    //   edge: 200,
    //   hAdjust: 72,
    //   dockPosition: "right",
    //   // "margin-top":20,
    //   onClose: function () {
    //     return !1;
    //   },
    // });
  };

  openAllFilter = (event) => {
    const { allFilterList, filterList, entryId } = this.state;
    let fArray = filterList.map((res) => {
      return res.entryId || res.appId;
    });

    let icon = document.querySelector(".bsy-frame-path-container .all-flow i");
    if (icon) {
      icon.style.transform = "rotate(180deg)";
      icon.style.display = "block";
    }

    BsyMsgBubble({
      anchor: event.currentTarget,
      contentHTML: (ref) => {
        return (
          <ShowFlowFormList
            fArray={fArray}
            entryId={entryId}
            allFilterList={allFilterList}
            selectFlowForm={(res) => {
              this.selectFlowForm(res, ref);
            }}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: 150,
      width: 230,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function () {
        icon.style.transform = "";
        icon.style.display = "";
        return !1;
      },
    });
  };

  showDingConfig = (event) => {
    event.currentTarget
      .getElementsByClassName("iconding")[0]
      .classList.add("hove");
  };

  hideDingConfig = (event) => {
    event.currentTarget
      .getElementsByClassName("iconding")[0]
      .classList.remove("hove");
  };

  showDingUnset = (res) => {
    return (event) => {
      let dingList = this.getFlowDingList("ding");
      if (dingList.indexOf(res.entryId) > -1) {
        event.currentTarget.classList.add("delete");
      } else {
        event.currentTarget.classList.add("unset");
      }
    };
  };
  hideDingUnset = (res) => {
    return (event) => {
      let dingList = this.getFlowDingList("ding");
      if (dingList.indexOf(res.entryId) > -1) {
        event.currentTarget.classList.remove("delete");
      } else {
        event.currentTarget.classList.remove("unset");
      }
    };
  };

  switchDing = (r) => {
    return (event) => {
      event.preventDefault();
      event.stopPropagation();
      let dingList = this.getFlowDingList("ding");
      if (dingList.indexOf(r.entryId) > -1) {
        dingList.splice(dingList.indexOf(r.entryId), 1);
      } else {
        dingList.push(r.entryId);
      }
      if (dingList.length > 3) {
        tipAlert({
          type: "warning",
          msg: React.language("flow.ding.max.len", { num: 3 }),
        });
        return;
      }
      this.setFlowDingList(dingList, "ding");
      this.reFilterList();
    };
  };

  filterLoad = (filter, search) => {
    //只有在执行筛选的时候，保存条件
    this.onSetFieldFilter(filter);
    this.setState(
      {
        filter: [...filter],
        search: search,
        page: 0,
        scrollDataLength: 0,
        isBatchForward: false,
      },
      () => {
        this.renderFlowIndex++;
        this.scrollLoad();
      }
    );
    // this.scrollLoad(true, filter);
  };

  toFilter = (filter) => {
    let ds = [];
    BsyUtils.forEach(filter, (index, data) => {
      ds.push(data);
    });
    return {
      cond: ds,
      rel: "and",
    };
  };

  loadScroll = true;

  async scrollLoadRequest(data) {
    const {
      appId,
      page,
      flowFormData,
      avatarMap,
      nameMap,
      isBatchForwardNum,
      scrollDataLength,
    } = this.state;
    let isBatchForwardNum1 = isBatchForwardNum;
    data.cacheKey = "refreshLoadRequest1";
    const res1 = await React.axios(
      `/dashboard/app/${appId}/workflow/query_data`,
      data
    );
    data.cacheKey = "refreshLoadRequest2";
    data.hascount = true;
    const res2 = await React.axios(
      `/dashboard/app/${appId}/workflow/query_data`,
      data
    );

    res1.data.data.map((res) => {
      if (res.allowBatchForward) {
        isBatchForwardNum1++;
      }
      return null;
    });
    BsyUtils.forEach(res1.data.avatarMap, (key, res) => {
      avatarMap[key] = res;
    });
    BsyUtils.forEach(res1.data.nameMap, (key, res) => {
      nameMap[key] = res;
    });
    let flowData = [];
    if (page !== 0) {
      flowData = [...flowFormData];
    } else {
      this.renderFlowIndex++;
    }
    this.setState(
      {
        flowFormData: flowData.concat(res1.data.data),
        avatarMap: avatarMap,
        isBatchForwardNum: isBatchForwardNum1,
        scrollDataLength: scrollDataLength + res1.data.data.length,
        nameMap: nameMap,
        isMore: res1.data.data.length ? true : false,
        count: res2.data.count,
      },
      () => {
        this.loadScroll = true;
      }
    );
  }

  scrollLoad = () => {
    const {
      entryId,
      appId,
      page,
      updateTime,
      selectForm,
      filter,
      scrollDataLength,
      count,
      search,
    } = this.state;
    // if (!hasScroll && r) {
    //     return
    // }
    // let filterList = {}
    // if (r) {
    //     filterList = r
    // }
    if (!this.loadScroll) {
      return;
    }
    if (count > 0 && scrollDataLength >= count) {
      return;
    }

    let data = {
      appId: appId,
      type: entryId,
      skip: page * 20,
      limit: 20,
      hascount: false,
      keyword: !search ? undefined : search,
      source: "pc",
      filter: this.toFilter([
        ...filter,
        {
          field: "entryId",
          type: "flowentry",
          hasEmpty: false,
          method: "eq",
          value: [selectForm.entryId],
        },
      ]),
      formId: selectForm.formId,
      entryId: selectForm.entryId,
      sort: {
        updateTime,
      },
    };

    if (entryId === "todo") {
      data.fastFilter = "todo";
      data.sort = {
        updateTime,
      };
    } else if (entryId === "cc") {
      data.fastFilter = "cc";
      data.sort = {
        updateTime,
      };
    } else if (entryId === "transactors") {
      data.fastFilter = "transactors";
      data.sort = {
        updateTime,
      };
    }

    this.loadScroll = false;

    this.scrollLoadRequest(data);

    // React.axios(`/dashboard/app/${appId}/workflow/query_data`, data).then(res => {
    //     res.data.data.map(res => {
    //         if (res.allowBatchForward) {
    //             isBatchForwardNum1++
    //         }
    //     })
    //     BsyUtils.forEach(res.data.avatarMap, (key, res) => {
    //         avatarMap[key] = res;
    //     })
    //     BsyUtils.forEach(res.data.nameMap, (key, res) => {
    //         nameMap[key] = res;
    //     })
    //     let flowData = [];
    //     if (page !== 0) {
    //         flowData = [...flowFormData]
    //     } else {
    //         this.renderFlowIndex++;
    //     }
    //     this.setState({
    //         flowFormData: flowData.concat(res.data.data),
    //         avatarMap: avatarMap,
    //         isBatchForwardNum: isBatchForwardNum1,
    //         scrollDataLength: scrollDataLength + res.data.data.length,
    //         nameMap: nameMap,
    //         isMore: res.data.data.length ? true : false,
    //     }, () => {

    //         if (data.type === 'cc') {
    //             this.queryCcUnread(data.appId, data.formId);
    //         }

    //         data.hascount = true;
    //         React.axios(`/dashboard/app/${appId}/workflow/query_data`, data).then(res => {
    //             this.loadScroll = true;
    //             this.setState({
    //                 count: res.data.count
    //             })
    //         })
    //     })
    // })
  };

  async loadFormFlowRequst(r, data) {
    const { entryId, appId, isBatchForwardNum } = this.state;
    let isBatchForwardNum1 = isBatchForwardNum;

    const res1 = await React.axios(
      `/dashboard/app/${appId}/workflow/get_form_fields`,
      {
        appId: appId,
        entryId: r.entryId,
        formId: r.formId,
        cacheKey: "loadFormFlowRequst1",
      }
    );
    // console.log('loadFormFlowRequst 1111');
    const res = await React.axios(
      `/dashboard/app/${appId}/workflow/get_flow_search_cache`,
      {
        appId: appId,
        entryId: r.entryId,
        formId: r.formId,
        type: entryId,
        source: "pc",
        cacheKey: "loadFormFlowRequst2",
      }
    );
    // console.log('loadFormFlowRequst 2222');

    let fields = res1.data;
    let fieldsList = [];
    fields.map((res) => {
      if (res.type === "subform") {
        res.items.map((res1) => {
          res1.text = res.text + "." + res1.text;
          res1.name = res.name + "." + res1.name;
          fieldsList.push(res1);
          return null;
        });
      } else {
        fieldsList.push(res);
      }
      return null;
    });
    switch (this.state.entryId) {
      case "todo":
        fieldsList.push({
          name: "flowcreator",
          type: "flowcreator",
          text: React.language("flow.creator"),
        });
        fieldsList.push({
          name: "createTime",
          type: "datetime",
          text: React.language("flow.createTime"),
        });
        fieldsList.push({
          name: "flowNode",
          type: "flownode",
          text: React.language("flow.node.current"),
        });
        fieldsList.push({
          name: "backflowid",
          type: "backflowid",
          text: React.language("flow.action.back") + React.language("node"),
        });
        break;
      case "cc":
        fieldsList.push({
          name: "flowcreator",
          type: "flowcreator",
          text: React.language("flow.creator"),
        });
        fieldsList.push({
          name: "createTime",
          type: "datetime",
          text: React.language("flow.createTime"),
        });
        fieldsList.push({
          name: "flowNode",
          type: "flownode",
          text: React.language("flow.node"),
        });
        break;
      case "transactors":
        fieldsList.push({
          name: "flowState",
          type: "flowstate",
          text: React.language("field.flowState"),
        });
        fieldsList.push({
          name: "flowcreator",
          type: "flowcreator",
          text: React.language("flow.creator"),
        });
        fieldsList.push({
          name: "createTime",
          type: "datetime",
          text: React.language("flow.createTime"),
        });
        fieldsList.push({
          name: "flowNode",
          type: "flownode",
          text: React.language("flow.node.current"),
        });
        break;
      case "create":
        fieldsList.push({
          name: "flowState",
          type: "flowstate",
          text: React.language("field.flowState"),
        });
        fieldsList.push({
          name: "createTime",
          type: "datetime",
          text: React.language("flow.createTime"),
        });
        fieldsList.push({
          name: "flowNode",
          type: "flownode",
          text: React.language("flow.node.current"),
        });
        break;
      default:
        fieldsList = [];
    }
    let filter = []; //BsyUtils.isObjectEmpty(res.data.filter) ? {} : [];
    BsyUtils.forEach(res.data?.filter?.cond || [], (index, data) => {
      if (
        [
          "urgeTime",
          "flowExpireTime",
          "startAction",
          "lastAction",
          "isread",
          "queryState",
        ].includes(data.field)
      ) {
        return true;
      }
      filter.push(data);
    });

    // {
    //     "field": "isread",
    //     "type": "isread",
    //     "hasEmpty": false,
    //     "method": "eq",
    //     value: [0]
    // }
    if (this.state.entryId === "cc") {
      filter.push({
        field: "isread",
        type: "isread",
        hasEmpty: false,
        method: "eq",
        value: [0],
      });
    }

    data.filter = this.toFilter([
      ...filter,
      {
        field: "entryId",
        type: "flowentry",
        hasEmpty: false,
        method: "eq",
        value: [r.formId],
      },
    ]);
    data.cacheKey = "loadFormFlowRequst3";
    const res2 = await React.axios(
      `/dashboard/app/${appId}/workflow/query_data`,
      data
    );
    // console.log('loadFormFlowRequst 3333');
    data.hascount = true;
    data.cacheKey = "loadFormFlowRequst4";
    const res3 = await React.axios(
      `/dashboard/app/${appId}/workflow/query_data`,
      data
    );
    // console.log('loadFormFlowRequst 4444');
    res2.data.data.map((res) => {
      if (res.allowBatchForward) {
        isBatchForwardNum1++;
      }
      return null;
    });
    if (this.filterContext.state.flowType === "cc") {
      this.queryCcUnread(appId, r.formId);
    }
    this.renderFlowIndex++;
    this.renderFlowFilterIndex++;
    this.setState({
      filter,
      showFilter: true,
      fields: fieldsList,
      flowFormData: res2.data.data,
      isBatchForwardNum: isBatchForwardNum1,
      isMore: res2.data.data.length ? true : false,
      avatarMap: res2.data.avatarMap,
      scrollDataLength: res2.data.data.length + this.state.scrollDataLength,
      nameMap: res2.data.nameMap,
      count: res3.data.count,
      allcount: res3.data.allcount,
      loadSuccess: true,
    });
  }

  loadFormFlow = (r) => {
    const { entryId, appId, updateTime } = this.state;
    let that = this;
    let data = {
      appId: appId,
      type: entryId,
      skip: 0,
      limit: 20,
      hascount: false,
      formId: r.formId,
      entryId: r.entryId,
      sort: {
        createTime: updateTime,
      },
    };

    if (entryId === "todo") {
      data.fastFilter = "todo";
      data.sort = {
        updateTime: updateTime,
      };
    } else if (entryId === "cc") {
      data.fastFilter = "cc";
      data.sort = {
        updateTime,
      };
    } else if (entryId === "transactors") {
      data.fastFilter = "transactors";
      data.sort = {
        updateTime,
      };
    }
    window.FX.STATIC.formId = r.formId;
    this.renderFlowIndex++;
    this.setState(
      {
        loadSuccess: false,
        showFilter: false,
        page: 0,
        scrollDataLength: 0,
        isMore: false,
        search: "",
      },
      () => {
        that.loadFormFlowRequst(r, data);
      }
    );
  };

  selectFlowForm = (r, ref) => {
    if (ref) {
      ref.closeAlter && ref.closeAlter();
    }

    this.setState(
      {
        page: 0,
        flowFormData: [],
        avatarMap: {},
        hasScroll: true,
        loadSuccess: false,
        isBatchForward: false,
        batchForwardList: [],
        isBatchForwardNum: 0,
        nameMap: {},
        isSelectAllFlow: r.entryId ? false : true,
      },
      () => {
        this.setFlowDingList([r.entryId || r.appId], "select");
        this.loadFormFlow(r);
        this.reFilterList("click", ref);
      }
    );
  };

  _toDeptUser = (a) => {
    const { nameMap } = this.state;
    let str = "";
    if (a && a.hasOwnProperty("nickname")) {
      str = a ? a.nickname : "";
    } else {
      str = BsyUtils._toDeptUser(nameMap[a]);
    }
    return str;
  };

  _formatData = (a) => {
    const { nameMap } = this.state;
    var b = this;
    if (BsyUtils.isEmpty(a.value)) return "";
    switch (a.type) {
      case "address":
      case "location":
        return BsyUtils.address2Str(a.value, "pcda");
      case "datetime":
        return BsyUtils.date2Str(dayjsUtils.timeToTZ(a.value), a.format);
      case "number":
        const res = BsyUtils.numberFormatValue(a.value, a);
        const afterSuffixVal = getAfterSuffix(a.afterSuffix)
        if (afterSuffixVal && res.text && !res.text.includes("%")) {
          res.text = res.text + ' ' + afterSuffixVal;
        }
        return res.text;
      case "user":
      case "dept":
        return this._toDeptUser(a.value);
      case "usergroup":
      case "deptgroup":
        let c = [];
        BsyUtils.forEach(a.value, function (a, d) {
          c.push(b._toDeptUser(d));
        });
        return c.join(",");
      default:
        return a.value;
    }
  };

  _formatItem = (a) => {
    const { entryId, nameMap } = this.state;
    if ("todo" === entryId) {
      a.creatorName = BsyUtils.isNull(a.creator)
        ? React.language("widget.user.anonymous")
        : BsyUtils._toDeptUser(nameMap[a.creator]);
      a.updateTime = BsyUtils.date2Str(
        dayjsUtils.timeToTZ(a.updateTime),
        "yyyy-MM-dd HH:mm:ss"
      );
      a.createTime = BsyUtils.date2Str(
        dayjsUtils.timeToTZ(a.createTime),
        "yyyy-MM-dd HH:mm:ss"
      );
    } else {
      let d = [];
      BsyUtils.forEach(a.chargers, function (a, c) {
        d.push(BsyUtils._toDeptUser(nameMap[c]));
      });
      a.chargersStr = d.join(",");
      a.creatorName = BsyUtils.isNull(a.creator)
        ? React.language("widget.user.anonymous")
        : BsyUtils._toDeptUser(nameMap[a.creator]);
      a.updateTime = BsyUtils.date2Str(
        dayjsUtils.timeToTZ(a.updateTime),
        "yyyy-MM-dd HH:mm:ss"
      );
      a.createTime = BsyUtils.date2Str(
        dayjsUtils.timeToTZ(a.createTime),
        "yyyy-MM-dd HH:mm:ss"
      );
    }
    if (a.updateTime)
      a.updateTime =
        BsyUtils.isString(a.updateTime) && a.updateTime.indexOf("T") === -1
          ? a.updateTime.replace(/-/g, "/")
          : a.updateTime;
    if (a.createTime)
      a.createTime =
        BsyUtils.isString(a.createTime) && a.createTime.indexOf("T") === -1
          ? a.createTime.replace(/-/g, "/")
          : a.createTime;
  };

  _editData = (b) => {
    return () => {
      let that = this;

      b.flowType = that.entryId;
      const { restore } = BsyUtils.globalIdManager(b.appId, b.entryId, b._id);
      let layerRef = null;
      BsyMaskLayer({
        customCls: "fadein-right",
        onMaskClick: (event) => {
          // if (event.target.classList.contains("fadein-right")) {
          //   layerRef.close();
          // }
        },
        onContentCreate: (ref) => {
          layerRef = ref;

          return (
            <BsyFormPane
              {...b}
              mode={"edit"}
              onSuccess={() => {
                restore();
                layerRef && layerRef.close();
                that.setState(
                  {
                    page: 0,
                    scrollDataLength: 0,
                  },
                  () => {
                    that.renderFlowIndex++;
                    that.scrollLoad();
                  }
                );
              }}
              onClose={(e) => {
                restore();
                if (e || b.flowType == "cc") {
                  that.setState(
                    {
                      page: 0,
                      scrollDataLength: 0,
                    },
                    () => {
                      that.renderFlowIndex++;
                      that.scrollLoad();
                    }
                  );
                }

                layerRef && layerRef.close();
              }}
            />
          );
        },
      });

      // let c = this;
      // this.$mask || (this.$mask = window.$('<div className="x-window-mask modal light"/>').css({
      //     "z-index": window.FX.STATIC.zIndex++
      // }).appendTo("body"));
      // // let i = window.BsyUtils.createLoadLayer(window.$("body"), {
      // //     isLight: !0,
      // //     isModal: !0
      // // });

      // this.form = new window.FX.FormEditPane({
      //     renderEl: window.$('<div className="x-shadow-content"/>').appendTo(this.$mask),
      //     width: 920,
      //     height: "100%",
      //     originPrint: "flow",
      //     appId: b.appId,
      //     dataId: b._id,
      //     entryId: b.entryId,
      //     flowType: c1,
      //     flowId: b.flowId,
      //     onSuccess: function () {

      //         //应用访问内层需要刷新列表
      //         const { filterList } = c.state;
      //         filterList.map((res, key) => {
      //             if (b.entryId === res.entryId) {
      //                 if (res.count > 0)
      //                     res.count--
      //                 filterList[key] = res
      //             }
      //         })
      //         c.setFlowDingList(filterList, "filter");
      //         // c.reFilterList();

      //         c.setState({
      //             page: 0,
      //             scrollDataLength: 0,
      //         }, () => {
      //             c.renderFlowIndex++;
      //             c.scrollLoad();
      //         })

      //         c._close();
      //         // c1.remove();
      //     },
      //     onFail: function () {
      //         c._close()
      //     },
      //     onCancel: function () {
      //         c._close()
      //     }
      // })
    };
  };
  _close = () => {
    this.$mask.remove();
    this.$mask = null;
    this.form = null;
    if (this.filterContext.state.flowType === "cc") {
      this.setState(
        {
          page: 0,
          scrollDataLength: 0,
        },
        () => {
          this.renderFlowIndex++;
          this.scrollLoad();
        }
      );
    }
  };

  onsetList = (evt) => {
    const { filterList } = this.state;

    let d1 = filterList.map((data) => {
      return data.entryId;
    });

    let d2 = evt.map((data) => {
      return data.entryId;
    });

    if (JSON.stringify(d2) !== JSON.stringify(d1)) {
      // console.log('onsetList', evt)

      this.setState(
        {
          filterList: [...evt],
        },
        () => {
          this.setFlowDingList(evt, "filter");
        }
      );
    }
  };

  switchBatchForward = () => {
    this.setState({
      isBatchForward: !this.state.isBatchForward,
    });
  };

  cancelBatchForward = () => {
    this.setState({
      isBatchForward: false,
    });
  };

  selectBatch = (r) => {
    return (event) => {
      event.preventDefault();
      event.stopPropagation();
      const { batchForwardList, isAllSelectBatch, isBatchForwardNum } =
        this.state;
      let isAllSelectBatch1 = isAllSelectBatch;
      let id = [r._id, r.flowId].join("-");
      if (batchForwardList.indexOf(id) > -1) {
        batchForwardList.splice(batchForwardList.indexOf(id), 1);
      } else {
        batchForwardList.push(id);
      }
      if (isBatchForwardNum === batchForwardList.length) {
        isAllSelectBatch1 = 2;
      } else {
        if (batchForwardList.length) {
          isAllSelectBatch1 = 1;
        } else {
          isAllSelectBatch1 = 0;
        }
      }
      this.setState({
        batchForwardList,
        isAllSelectBatch: isAllSelectBatch1,
      });
    };
  };

  selectAllBatch = () => {
    const { batchForwardList, isAllSelectBatch, flowFormData } = this.state;
    let isAllSelectBatch1 = isAllSelectBatch;
    let batchForwardList1 = batchForwardList;
    if (isAllSelectBatch1) {
      batchForwardList1 = [];
      isAllSelectBatch1 = 0;
    } else {
      flowFormData.map((res) => {
        if (res.allowBatchForward) {
          let id = [res._id, res.flowId].join("-");
          if (batchForwardList1.indexOf(id) < 0) {
            batchForwardList1.push(id);
          }
        }
        return null;
      });
      isAllSelectBatch1 = 2;
    }

    this.setState({
      batchForwardList: batchForwardList1,
      isAllSelectBatch: isAllSelectBatch1,
    });
  };

  batchajaxloing = !1;

  submitBatchForward = () => {
    const { batchForwardList, flowFormData, entryId } = this.state;
    let data_list = [];
    let appId = "";
    let entryId1 = "";

    let ddMap = {};

    flowFormData.map((res) => {
      let id = [res._id, res.flowId].join("-");

      if (batchForwardList.indexOf(id) > -1) {
        appId = res.appId;
        entryId1 = res.entryId;

        ddMap[res._id] = ddMap[res._id] || [];
        ddMap[res._id] = ddMap[res._id].concat(res.batchFlowIds);
        // data_list.push({
        //     data_id: res._id,
        //     flow_ids: res.batchFlowIds,
        // })
      }
      return null;
    });

    BsyUtils.forEach(ddMap, (index, data) => {
      data_list.push({
        data_id: index,
        flow_ids: data,
      });
    });
    if (BsyUtils.isObjectEmpty(data_list)) {
      tipAlert({
        type: "warning",
        msg: React.language("data.operation.select"),
      });
      return;
    }
    if (this.batchajaxloing) {
      return;
    }
    this.batchajaxloing = !0;
    React.axios(`/dashboard/app/${appId}/workflow/batch_forward`, {
      appId,
      entryId: entryId1,
      form_id: entryId1,
      data_list,
    })
      .then((res) => {
        BsyAlert({
          title: React.language("submit.finish"),
          msg: React.language("batch.forward.finish.tip", {
            success: res.data.success,
            fail: res.data.failure,
          }),
          type: "success",
          text4Ok: React.language("ok"),
          OkType: "blue",
          text4Cancel: "",
          ok: () => {
            this.setState(
              {
                isAllSelectBatch: 0,
                isBatchForward: false,
                batchForwardList: [],
              },
              () => {
                this.batchajaxloing = !1;
                React.axios(`/dashboard/app/${appId}/workflow/form_filter`, {
                  appId: appId,
                  ding: [],
                  type: entryId,
                })
                  .then((res) => {
                    BsyUtils.showAjaxTip(res.data, () => {
                      const data =
                        entryId === "todo"
                          ? res.data.length
                            ? [...res.data]
                            : []
                          : res.data;
                      this.setState(
                        {
                          titleName:
                            this.FlowMenuData[entryId].text +
                            " - " +
                            this.props.appName,
                          filterList: data,
                          allFilterList: data,
                          showContentEmpty: res.data.length,
                        },
                        () => {
                          if (data.length)
                            this.loadContentByFlow(
                              this.FlowMenuData[entryId],
                              entryId
                            );
                          else {
                            // document.querySelector(".header-flow") &&
                            //   document.querySelector(".header-flow").remove();
                          }
                          this.setEntryCache();
                        }
                      );
                    });
                  })
                  .catch((res) => {
                    console.error(res);
                  });
              }
            );
            return true;
          },
        });
      })
      .catch(() => {
        this.batchajaxloing = !1;
      });
  };

  async refreshLoadRequest(data) {
    const { appId, avatarMap, nameMap, isBatchForwardNum } = this.state;
    let isBatchForwardNum1 = isBatchForwardNum;
    data.cacheKey = "refreshLoadRequest1";
    const res1 = await React.axios(
      `/dashboard/app/${appId}/workflow/query_data`,
      data
    );
    data.cacheKey = "refreshLoadRequest2";
    data.hascount = true;
    const res2 = await React.axios(
      `/dashboard/app/${appId}/workflow/query_data`,
      data
    );

    res1.data.data.map((res) => {
      if (res.allowBatchForward) {
        isBatchForwardNum1++;
      }
      return null;
    });
    BsyUtils.forEach(res1.data.avatarMap, (key, res) => {
      avatarMap[key] = res;
    });
    BsyUtils.forEach(res1.data.nameMap, (key, res) => {
      nameMap[key] = res;
    });

    this.setState({
      flowFormData: res1.data.data,
      isMore: res1.data.data.length ? true : false,
      avatarMap: avatarMap,
      isBatchForwardNum: isBatchForwardNum1,
      scrollDataLength: res1.data.data.length,
      nameMap: nameMap,
      page: 0,
      count: res2.data.count,
    });
  }

  refreshLoad = () => {
    const { entryId, appId, updateTime, selectForm, filter } = this.state;
    let data = {
      appId: appId,
      type: entryId,
      skip: 0,
      limit: 20,
      hascount: false,
      filter: this.toFilter([
        ...filter,
        {
          field: "entryId",
          type: "flowentry",
          hasEmpty: false,
          method: "eq",
          value: [selectForm.entryId],
        },
      ]),
      formId: selectForm.formId,
      entryId: selectForm.entryId,
      sort: {
        createTime: -1,
      },
    };

    if (entryId === "todo") {
      data.fastFilter = "todo";
      data.sort = {
        updateTime,
      };
    } else if (entryId === "cc") {
      data.fastFilter = "cc";
      data.sort = {
        updateTime,
      };
    } else if (entryId === "transactors") {
      data.fastFilter = "transactors";
      data.sort = {
        updateTime,
      };
    }

    this.refreshLoadRequest(data);

    // React.axios(`/dashboard/app/${appId}/workflow/query_data`, data).then(res => {
    //     res.data.data.map(res => {
    //         if (res.allowBatchForward) {
    //             isBatchForwardNum1++
    //         }
    //     })
    //     BsyUtils.forEach(res.data.avatarMap, (key, res) => {
    //         avatarMap[key] = res;
    //     })
    //     BsyUtils.forEach(res.data.nameMap, (key, res) => {
    //         nameMap[key] = res;
    //     })
    //     this.setState({
    //         flowFormData: res.data.data,
    //         isMore: res.data.data.length ? true : false,
    //         avatarMap: avatarMap,
    //         isBatchForwardNum: isBatchForwardNum1,
    //         scrollDataLength: res.data.data.length,
    //         nameMap: nameMap,
    //         page: 0
    //     }, () => {
    //         data.hascount = true;
    //         data.cacheKey = "refreshLoadhascount";
    //         React.axios(`/dashboard/app/${appId}/workflow/query_data`, data).then(res => {
    //             this.setState({
    //                 count: res.data.count
    //             })
    //         })
    //     })
    // })
  };

  onLoadFilter = () => {
    const { appId, entryId, selectForm } = this.state;
    React.axios(`/dashboard/app/${appId}/workflow/get_flow_search_cache`, {
      appId: appId,
      entryId: selectForm.entryId,
      formId: selectForm.formId,
      type: entryId,
      source: "pc",
    }).then((res) => {
      this.setState({
        filter: res.data.filter ? res.data.filter.cond : [],
      });
    });
  };

  onSetFieldFilter = (t) => {
    const { appId, entryId, selectForm } = this.state;
    React.axios(`/dashboard/app/${appId}/workflow/set_flow_search_cache`, {
      appId: appId,
      entryId: selectForm.entryId,
      filter: this.toFilter(t),
      formId: selectForm.formId,
      type: entryId,
    }).then(() => { });
  };

  onResetFilter = () => {
    this.bsyDashContext.ResetFilter();
  };

  getDashContext = (context) => {
    this.bsyDashContext = context;
  };

  getDashRelContext = (context) => {
    this.dashRel = context;
  };

  onFilterShow = (show) => {
    this.show = show;
  };

  renderDataTable = () => {
    const {
      formConfig,
      entryId,
      appId,
      authGroupId,
      authGroupMap,
      is_dock_form,
      appType,
    } = this.state;

    if (BsyUtils.isObjectEmpty(authGroupId)) {
      return <></>;
    }
    if (authGroupId === -1) {
      return <></>;
    }
    if (authGroupMap && !authGroupMap[authGroupId]) {
      return <></>;
    }

    let f = authGroupMap[authGroupId];

    let ptlist = [];
    if (f.printId) {
      BsyUtils.forEach(f.printId, function (k, v) {
        ptlist.push({
          printId: k,
          name: v.name,
        });
      });
    }

    let showFields = [];
    window.$.map(f.optAuth, function (v, k) {
      if (v.visible) showFields.push(k);
    });
    let g = BsyUtils.Store.getKey("paramFields", {
      appId: appId,
      entryId: entryId,
      groupId: authGroupId,
    });
    var h = BsyUtils.Store.getKey("showFields", {
      appId: appId,
      entryId: entryId,
      groupId: authGroupId,
    });
    var i = BsyUtils.Store.getKey("metaFields", {
      appId: appId,
      entryId: entryId,
      groupId: authGroupId,
    });
    window.FX.STATIC.DECISION_SWITCH =
      formConfig.flow &&
        formConfig.flow.decision &&
        formConfig.flow.decision.switch
        ? formConfig.flow.decision.switch
        : false;

    let config = {
      appType: appType,
      appId: formConfig.appId,
      entryId: formConfig.entryId,
      formName: formConfig.name,
      formTabs: formConfig.formTabs,
      formTabsStyle: formConfig.formTabsStyle || {},
      formItems: formConfig.content.items,
      submitAttr: formConfig.content.submitAttr,
      data_cache: formConfig.content.data_cache,
      initializeModuleEvent: formConfig.content.initializeModuleEvent,
      initializeDataExtendSet: formConfig.content.initializeDataExtendSet,
      formAttr: {
        submitRule: formConfig.content.submitRule,
        layout: formConfig.content.layout,
        validators: formConfig.content.validators,
        confirmSettings: formConfig.content.confirmSettings,
        fieldShowRules: formConfig.content.fieldShowRules,
        subformFieldShowRules: formConfig.content.subformFieldShowRules,
      },
      originPrint: "group",
      enableRowEdit: formConfig.enableRowEdit,
      quickEdit: formConfig.quickEdit,
      hasExtParams: formConfig.hasExtParams,
      hasUserSource: formConfig.hasUserSource === true,
      hasFlow: formConfig.hasFlow,
      hasCoop: formConfig.hasCoop,
      flow: formConfig.flow,
      dataPerms: f.dataPerms,
      optAuth: f.optAuth,
      ptlist: ptlist,
      authGroupId: authGroupId,
      showFieldsFilter: window.FX.Store.get(g),
      showFields: window.FX.Store.get(h),
      showFieldsMeta: window.FX.Store.get(i),
      printId: f.printId,
      is_dock_form: is_dock_form,
      onParamFieldSelect: function (a) {
        window.FX.Store.set(g, a);
      },
      onDataFieldSelect: function (a) {
        window.FX.Store.set(h, a);
      },
      onDataFieldMetaChange: function (a) {
        window.FX.Store.set(i, a);
      },
    };

    return <BsyDataManage {...config} />;
  };
  highlighterText = (text, color) => {
    const { search } = this.state;
    let keyword = search;
    return BsyUtils.highlighterText(keyword, text, color);
  };

  setCCItemUnreadStyle = (data) => {
    if (this.filterContext && this.filterContext.state.flowType === "cc") {
      if (!data.hasOwnProperty("unread")) {
        return " cc-read ";
      }
      if (!data.unread) {
        return " cc-read ";
      }
    }
    return "";
  };

  renderUrgedStatus = (isUrged) => {
    if (!isUrged) {
      return "";
    }
    return <div className="todoIsUrged">{React.language("flow.Urge.one")}</div>;
  };

  renderFlowSourceStatus = (ct, res) => {
    const { entryId } = this.state;

    //  'save' => '暂存'
    //  'back' => '回退'
    // 'revoke' => '撤回'
    // 'active' => '激活',
    // 'transfer' => '转交',

    let types = [
      "save",
      "back",
      "revoke",
      "activate",
      "transfer",
      "sign",
      "sign_before",
      "sign_after",
      "sign_parallel",
    ];

    if (
      (!res.startAction && !res.lastAction) ||
      (!types.includes(res.startAction) && !types.includes(res.lastAction))
    ) {
      return (
        <>
          {res.backflowid != 0 && (
            <div className="infoBack">
              {React.language("form.backflowidName", {
                name: res.backflowidName,
              })}
            </div>
          )}

          {entryId === "todo" && res.backflowid == 0 && (
            <div className="waitedTime">{ct}</div>
          )}
        </>
      );
    }

    if (res.startAction === res.lastAction) {
      res.lastAction = "";
    }

    return (
      <div className="source-status">
        {types.includes(res.startAction) ? (
          <div
            className={"status-item " + res.startAction}
            title={
              res.startAction === "back"
                ? React.language("form.backflowidName.title", {
                  name: res.backflowidName,
                }) + React.language("form.backflowidName.end")
                : ""
            }
          >
            {res.startAction === "back" ? (
              <>
                <div className="name-title">
                  {React.language("form.backflowidName.title", {
                    name: res.backflowidName,
                  })}
                </div>
                <div className="name-end">
                  {React.language("form.backflowidName.end")}
                </div>
              </>
            ) : (
              React.language("flow.action." + res.startAction)
            )}
          </div>
        ) : (
          ""
        )}
        {types.includes(res.lastAction) ? (
          <div
            className={"status-item " + res.lastAction}
            title={
              res.startAction === "back"
                ? React.language("form.backflowidName.title", {
                  name: res.backflowidName,
                }) + React.language("form.backflowidName.end")
                : ""
            }
          >
            {res.lastAction === "back" ? (
              <>
                <div className="name-title">
                  {React.language("form.backflowidName.title", {
                    name: res.backflowidName,
                  })}
                </div>
                <div className="name-end">
                  {React.language("form.backflowidName.end")}
                </div>
              </>
            ) : (
              React.language("flow.action." + res.lastAction)
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  renderForm = () => {
    const { formConfig, authGroupId } = this.state;

    return (
      <BsyFormPane
        formConfig={formConfig}
        authGroupId={isNil(authGroupId) ? null : authGroupId}
        hasHeader={false}
        loading={false}
        mode={"new"}
      >
        {" "}
      </BsyFormPane>
    );
  };

  // 快捷处理事件
  onFlowItemQuickEvent = (item, type) => {
    let that = this;
    console.log(item, type);
    if (this.loading) {
      console.log("请求执行中");
      return;
    }
    that.loading = true;
    const submit = (ext) => {
      let layerRef = null;
      BsyMaskLayer({
        customCls: "sloading",
        onContentCreate: (ref) => {
          layerRef = ref;
          return (
            <div>
              <BsySLoading />
            </div>
          );
        },
      });
      React.axios("/data/update", {
        appId: item.appId,
        entryId: item.entryId,
        formId: item.formId || item.entryId,
        dataId: item._id,
        flowId: item.flowId,
        flowType: "todo",
        flowAction: type,
        ...ext,
      })
        .then((res) => {
          layerRef && layerRef.close();
          that.loading = false;
          BsyUtils.showAjaxTip(
            res.data,
            () => {
              that.setState(
                {
                  page: 0,
                  scrollDataLength: 0,
                },
                () => {
                  that.renderFlowIndex++;
                  that.scrollLoad();
                }
              );
            },
            () => {
              that.setState(
                {
                  page: 0,
                  scrollDataLength: 0,
                },
                () => {
                  that.renderFlowIndex++;
                  that.scrollLoad();
                }
              );
            }
          );
        })
        .catch(() => {
          layerRef && layerRef.close();
          that.loading = false;
        });
    };

    switch (type) {
      case "back": {
        _switchBackNode(
          {
            appId: item.appId,
            entryId: item.entryId,
            formId: item.formId || item.entryId,
            dataId: item._id,
            flowId: item.flowId,
          },
          (res) => {
            submit({ backnode: res });
          },
          () => {
            that.loading = false;
          }
        );
        break;
      }
      case "sign": {
        // todo 等后端返回 allowSignTypes
        _submitSign(
          {
            appId: item.appId,
            entryId: item.entryId,
            formId: item.formId || item.entryId,
            dataId: item._id,
            flowId: item.flowId,
          },
          item.allowSignTypes || [],
          (res) => {
            submit(res);
          },
          () => {
            that.loading = false;
          }
        );
        break;
      }
      case "transfer": {
        // todo 等后端返回 candidates
        _switchTransferChargers(
          {
            limit: item.candidates ? item.candidates.limit : {},
            appId: item.appId,
            entryId: item.entryId,
            formId: item.formId || item.entryId,
            dataId: item._id,
            flowId: item.flowId,
          },
          (res) => {
            submit({ candidateId: res });
          },
          () => {
            that.loading = false;
          }
        );
        break;
      }

      case "forward":
        _switchSubmit(
          {
            appId: item.appId,
            entryId: item.entryId,
            formId: item.formId || item.entryId,
            dataId: item._id,
            flowId: item.flowId,
            flowType: "todo",
          },
          (res) => {
            submit(res);
          }
        );
        break;
      default:
        submit();
    }
  };

  flowListPane = () => {
    const {
      fields,
      filter,
      loadSuccess,
      updateTime,
      page,
      entryId,
      appId,
      filterList,
      showAllFilter,
      isAllSelectBatch,
      scrollDataLength,
      batchForwardList,
      flowFormData,
      avatarMap,
      count,
      selectForm,
      isBatchForward,
      search,
      allcount,
    } = this.state;
    return (
      <>
        <div className="bsy-frame-path-container">
          {this.renderSidebar()}
          <div className="bsy-frame-path" ref={this.path}>
            <div className="header-flow">
              {entryId === "todo" && (
                <div
                  key={"allflow"}
                  className={
                    "header-itme " +
                    (this.state.isSelectAllFlow ? "sortable-selected" : "")
                  }
                  id={"allflow"}
                  onMouseDown={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.selectFlowForm({
                      ...this.allFlowNode,
                      appId: appId,
                    });
                  }}
                >
                  <div className="item">
                    <div className="icon">
                      <i
                        className={`icon-form-flow ${this.allFlowNode.icon > 24
                          ? "icon-new-bsy-form-" + this.allFlowNode.icon
                          : "icon-bby-form-" + this.allFlowNode.icon
                          }`}
                      />
                    </div>
                    <div className="text" title={this.allFlowNode.name}>
                      {this.allFlowNode.name}
                    </div>
                  </div>
                  <div
                    className="close"
                    style={{
                      visibility: "hidden",
                    }}
                  >
                    <i className="icon-bby-close-small" />
                  </div>
                  {/* <div className={"iconding " + (dingList.indexOf(res.entryId) > -1 ? "ding" : "")} onClick={this.switchDing(res)} onMouseEnter={this.showDingUnset(res)} onMouseLeave={this.hideDingUnset(res)} /> */}
                </div>
              )}

              <ReactSortable
                style={{
                  display: "flex",
                }}
                forceFallback={"true"}
                list={filterList}
                setList={this.onsetList}
                // filter={'.iconding,.close'}
                handle={".item"}
              >
                {filterList.map((res) => {
                  return (
                    res && (
                      <div
                        key={res.appId + res.entryId + res.count}
                        className={
                          "header-itme " +
                          ` flow-${res.entryId}` +
                          (res.selected ? "select" : "")
                        }
                        id={res.entryId}
                        onMouseDown={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          this.selectFlowForm(res);
                        }}
                      >
                        <div className="item">
                          <div className="icon">
                            <i
                              className={`icon-form-flow ${res.icon > 24
                                ? "icon-new-bsy-form-" + res.icon
                                : "icon-bby-form-" + res.icon
                                }`}
                            />
                          </div>
                          <div className="text" title={res.name}>
                            {res.name}
                          </div>
                          {entryId === "todo" && res.count > 0 && (
                            <div className="todonum" title={res.count}>
                              ({res.count})
                            </div>
                          )}
                        </div>
                        <div
                          className="close"
                          onClick={this.removeFilterList(res)}
                          style={
                            {
                              // visibility: res.entryId ? "visible" : "hidden",
                            }
                          }
                        >
                          <i className="icon-bby-close-small" />
                        </div>
                        {/* <div className={"iconding " + (dingList.indexOf(res.entryId) > -1 ? "ding" : "")} onClick={this.switchDing(res)} onMouseEnter={this.showDingUnset(res)} onMouseLeave={this.hideDingUnset(res)} /> */}
                      </div>
                    )
                  );
                })}
              </ReactSortable>

              {showAllFilter && (
                <div className="all all-flow" onClick={this.openAllFilter}>
                  <div className="text">{React.language("flow.todo.all")}</div>
                  <div className="icon">
                    <i className="icon-bsy-xia" />
                  </div>
                </div>
              )}
            </div>
          </div>
          <BsySystemRightMenu search={false} />
        </div>

        <div
          className={
            "bsy-frame-entry-content flow-content" +
            (isBatchForward ? " batch-forward" : "")
          }
          ref={this.content}
        // key={'render-' + this.renderFlowIndex}
        >
          <BsyDashboardFlowFilter
            getContext={(e) => {
              this.filterContext = e;
            }}
            getFlowData={() => {
              return flowFormData;
            }}
            search={search}
            allcount={allcount}
            loadFlowList={this.filterLoad}
            key={"appId-" + this.renderFlowFilterIndex}
            // key={appId + selectForm.entryId + entryId}
            appId={appId}
            // onSetFieldFilter={this.onSetFieldFilter}
            entryId={selectForm.entryId}
            flowType={entryId}
            filter={filter}
            fields={fields}
            show={this.show}
            onFilterShow={this.onFilterShow}
            onLoadFilter={this.onLoadFilter}
            isBatchForward={isBatchForward}
            updateTime={updateTime}
            switchBatchForward={this.switchBatchForward}
            refreshLoad={this.refreshLoad}
            sortTime={this.sortTime}
          />

          <div className="bsy-flow-list-container" onScroll={this.scrollFunc}>
            <div
              className={
                " bsy-flow-list " + (isBatchForward ? "batchforward" : "")
              }
              ref={this.flowContent}
              style={{ background: "rgb(245, 251, 255)" }}
            >
              {isBatchForward && (
                <div className="batch-forward-toolbar">
                  <div className="left-toolbar">
                    <div
                      className="authAllSelect"
                      onClick={this.selectAllBatch}
                    >
                      <i
                        className={
                          isAllSelectBatch === 2
                            ? "icon-bsy-select"
                            : isAllSelectBatch === 0
                              ? "icon-bsy-check2"
                              : "icon-new-bsy-partial-select"
                        }
                      ></i>
                      <span>{React.language("batch.forward.select.all")}</span>
                    </div>
                    <div
                      className="tip"
                      dangerouslySetInnerHTML={{
                        __html: React.language("batch.forward.select.tip", {
                          count:
                            "<span class='batch-count'>" +
                            batchForwardList.length +
                            "</span>",
                        }),
                      }}
                    />
                  </div>
                  <div className="right-toolbar">
                    <div
                      className="btn cancel"
                      onClick={this.cancelBatchForward}
                    >
                      <span>{React.language("data.cancelOperation")}</span>
                    </div>
                    <div className="btn ok" onClick={this.submitBatchForward}>
                      <span>{React.language("submit.select")}</span>
                    </div>
                  </div>
                </div>
              )}
              {loadSuccess && (
                <ul
                  className="flow-list"
                  key={"flowlist-key" + this.renderFlowIndex}
                >
                  {flowFormData.length > 0 ? (
                    flowFormData.map((res) => {
                      this._formatItem(res);
                      let y = avatarMap[res.creator]
                        ? avatarMap[res.creator]
                        : "/template/bbymember/images/avatar_default.jpg";
                      let s = res.creatorName
                        ? res.creatorName
                        : React.language("widget.user.anonymous");
                      let bg = BsyUtils.formatUserThumb(s);
                      let c = "";
                      let d = "";
                      let p = "";
                      BsyUtils.isArray(res.states) &&
                        (c = res.states.join("，"));
                      let u = window.FX.CONST.WORKFLOW.FLOWSTATE;
                      let m =
                        window.FX.CONST.FLOW_FAIL_HINT[res.flowFailureAction];
                      let g = null;
                      let v = "";
                      let F = "";
                      let td = "";
                      let leftd = "";
                      let lefth = "";
                      let leftm = "";
                      let lefts = "";
                      let ceftd = "";
                      let cefth = "";
                      let ceftm = "";
                      let cefts = "";
                      let lt = "";
                      //兼容IOS mac os 写法 IOS 只支持 2020/8/8这类格式
                      res.updateTime =
                        BsyUtils.isString(res.updateTime) &&
                          res.updateTime.indexOf("T") === -1
                          ? res.updateTime.replace(/-/g, "/")
                          : res.updateTime;
                      res.createTime =
                        BsyUtils.isString(res.createTime) &&
                          res.updateTime.indexOf("T") === -1
                          ? res.updateTime.replace(/-/g, "/")
                          : res.createTime;
                      let ct =
                        dayjsUtils.timeToTZ(res.updateTime).getTime() -
                        dayjsUtils.timeToTZ(new Date()).getTime();
                      let f =
                        "create" === entryId ? res.createTime : res.updateTime;
                      // let f = res.createTime;
                      let t =
                        dayjsUtils.timeToTZ(res.createTime).getTime() -
                        dayjsUtils.timeToTZ(new Date()).getTime();

                      if (t <= -259200000) {
                        td = "red";
                        t = Math.abs(t);
                        leftd = Math.floor(t / (1000 * 60 * 60 * 24)); //计算天数
                        lefth = Math.floor((t / (1000 * 60 * 60)) % 24); //计算小时数
                        leftm = Math.floor((t / (1000 * 60)) % 60); //计算分钟数
                        lefts = Math.floor((t / 1000) % 60); //计算秒数
                        if (leftd !== 0 && lefth === 0 && leftm === 0) {
                          lt = "已超时" + leftd + React.language("days");
                        } else if (leftd === 0 && lefth !== 0 && leftm === 0) {
                          lt = "已超时" + lefth + React.language("to.hour");
                        } else if (leftd === 0 && lefth === 0 && leftm !== 0) {
                          lt = "已超时" + leftm + React.language("to.minute");
                        } else {
                          lt =
                            "已超时" +
                            leftd +
                            React.language("days") +
                            lefth +
                            React.language("to.hour") +
                            leftm +
                            React.language("to.minute");
                        }
                      } else {
                        td = "bule";
                        t = Math.abs(t);
                        leftd = Math.floor(t / (1000 * 60 * 60 * 24)); //计算天数
                        lefth = Math.floor((t / (1000 * 60 * 60)) % 24); //计算小时数
                        leftm = Math.floor((t / (1000 * 60)) % 60); //计算分钟数
                        lefts = Math.floor((t / 1000) % 60); //计算秒数
                        if (leftd === 0 && lefth === 0 && leftm === 0) {
                          lt = "刚刚";
                        } else if (leftd !== 0 && lefth === 0 && leftm === 0) {
                          lt = leftd + React.language("days");
                        } else if (leftd === 0 && lefth !== 0 && leftm === 0) {
                          lt = lefth + React.language("to.hour");
                        } else if (leftd === 0 && lefth === 0 && leftm !== 0) {
                          lt = leftm + React.language("to.minute");
                        } else {
                          lt =
                            leftd +
                            React.language("days") +
                            lefth +
                            React.language("to.hour") +
                            leftm +
                            React.language("to.minute");
                        }
                      }
                      ct = Math.abs(ct);
                      ceftd = Math.floor(ct / (1000 * 60 * 60 * 24)); //计算天数
                      cefth = Math.floor((ct / (1000 * 60 * 60)) % 24); //计算小时数
                      ceftm = Math.floor((ct / (1000 * 60)) % 60); //计算分钟数
                      cefts = Math.floor((ct / 1000) % 60); //计算秒数
                      if (ceftd !== 0 && cefth === 0 && ceftm === 0) {
                        ct =
                          React.language("waiting.new") +
                          ceftd +
                          React.language("days");
                      } else if (ceftd === 0 && cefth !== 0 && ceftm === 0) {
                        ct =
                          React.language("waiting.new") +
                          cefth +
                          React.language("to.hour");
                      } else if (ceftd === 0 && cefth === 0 && ceftm !== 0) {
                        ct =
                          React.language("waiting.new") +
                          ceftm +
                          React.language("to.minute");
                      } else {
                        ct =
                          React.language("waiting.new") +
                          ceftd +
                          React.language("days") +
                          cefth +
                          React.language("to.hour") +
                          ceftm +
                          React.language("to.minute");
                      }

                      if (res.flowExpireTime) {
                        g = BsyUtils.getDateInfoFromNow(res.flowExpireTime);
                        v = g.isLater ? "" : "overtime";
                        F = "";
                        if (g.isJustNow) {
                          F = React.language("flow.list.date.just");
                        } else {
                          if (g.day >= 30) {
                            F = React.language("flow.list.date.longAgo");
                          } else {
                            if (g.day) {
                              F += g.day + React.language("days");
                            } else {
                              F += "";
                            }
                            if (g.hour) {
                              F += g.hour + React.language("to.hour");
                            } else {
                              F += "";
                            }
                            if (!(v && F)) {
                              if (g.minute) {
                                F += g.minute + React.language("to.minute");
                              } else {
                                F += "";
                              }
                            }
                          }
                        }
                        if (res.isUrged) {
                          v = "overtime";
                          F = g.isLater
                            ? F
                            : React.language("has.timed.out") + F;
                        }
                      }

                      switch (res.flowState) {
                        case u.COMPLETE:
                          c = "";
                          d = React.language("flow.node.end");
                          p = "complete";
                          break;
                        case u.CLOSE:
                          c = "";
                          d = React.language("flow.state.closed");
                          p = "closed";
                          break;
                        case u.INPROCESS:
                          d = React.language("flow.state.inProcess");
                          p = "in-process";
                          break;
                        default:
                      }
                      if (!BsyUtils.isObjectEmpty(res.flowDecision)) {
                        if (res.flowDecision.state_id != 0) {
                          switch (parseInt(res.flowDecision.state_id)) {
                            case 1: {
                              p = "through";
                              break;
                            }

                            case 2: {
                              p = "refuse";
                              break;
                            }

                            default:
                          }
                          d = res.flowDecision.state;
                        }
                      }
                      let id = [res._id, res.flowId].join("-");
                      return (
                        <li
                          key={id}
                          className={
                            "flow-item line-item " +
                            entryId +
                            this.setCCItemUnreadStyle(res)
                          }
                          onClick={this._editData(
                            { ...res, dataId: res._id },
                            entryId
                          )}
                        >
                          <div className="line-item-header">
                            <div className="left">
                              <div className="entry-name" title={res.entryName}>
                                {this.highlighterText(res.entryName)}
                              </div>
                              {res.flowState == 0 ? (
                                <div
                                  className="flow-charge-1"
                                  onMouseEnter={(e) => {
                                    if (res.flowName) {
                                      this.showTooltip(
                                        e.currentTarget,
                                        res.states.join("、"),
                                        "top",
                                        0
                                      );
                                    }
                                  }}
                                  onMouseLeave={this.hideTooltip}
                                >
                                  <span className="current-node">
                                    <i className="icon-subflow"></i>
                                    {this.highlighterText(
                                      res.states.join("、")
                                    )}
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                              {this.renderUrgedStatus(res.isUrged)}
                              {this.renderFlowSourceStatus(ct, res)}
                              {res.flowState != 1 &&
                                res.flowState != 2 &&
                                entryId != "todo" ? (
                                <div
                                  className="flow-charge-1 charge"
                                  onMouseEnter={(e) => {
                                    if (res.chargersStr) {
                                      this.showTooltip(
                                        e.currentTarget,
                                        res.chargersStr,
                                        "top",
                                        0
                                      );
                                    }
                                  }}
                                  onMouseLeave={this.hideTooltip}
                                >
                                  {this.highlighterText(res.chargersStr)}{" "}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="right">
                              {["todo", "cc"].indexOf(entryId) == -1 ? (
                                res.flowState === 0 ? (
                                  <div className="bsy-flow-state  in-process">
                                    {React.language("flow.state.inProcess")}
                                  </div>
                                ) : res.flowState === 1 ? (
                                  <div className="bsy-flow-state  complete">
                                    {React.language("flow.node.end")}
                                  </div>
                                ) : (
                                  <div className="bsy-flow-state  closed">
                                    {React.language("flow.state.closed")}
                                  </div>
                                )
                              ) : (
                                ""
                              )}
                              <div
                                className="flow-time"
                                onMouseEnter={(e) => {
                                  var tipText =
                                    "create" === entryId
                                      ? React.language("flow.time.start")
                                      : "transactors" === entryId
                                        ? React.language(
                                          "flow.my.transactors.time"
                                        )
                                        : "cc" === entryId
                                          ? React.language("flow.my.cc.time")
                                          : "";
                                  if (!tipText) {
                                    return;
                                  }
                                  this.showTooltip(
                                    e.currentTarget,
                                    tipText,
                                    "bottom",
                                    10
                                  );
                                }}
                                onMouseLeave={this.hideTooltip}
                              >
                                {this.highlighterText(f)}
                              </div>
                              {entryId === "todo" &&
                                res.flowFailureAction &&
                                (m ? (
                                  <div
                                    className={
                                      "flow-hint fail-hint " +
                                      (res.isUrged ? " overtime" : "")
                                    }
                                  >
                                    {m}
                                  </div>
                                ) : res.flowExpireTime ? (
                                  <div
                                    className={
                                      "flow-hint expire-time-hint " + v
                                    }
                                  >
                                    <i className="time-icon icon-alarm-o" />
                                    {F}
                                  </div>
                                ) : (
                                  ""
                                ))}
                              {"todo" === entryId &&
                                !res.flowFailureAction &&
                                (res.flowExpireTime ? (
                                  <div
                                    className={
                                      "flow-hint expire-time-hint " + v
                                    }
                                  >
                                    <i className="time-icon icon-alarm-o" />
                                    {F}
                                  </div>
                                ) : (
                                  ""
                                ))}
                            </div>
                          </div>
                          <div className="line-item-content">
                            {isBatchForward && (
                              <div className="itemSelect">
                                {res.allowBatchForward && (
                                  <div
                                    className={
                                      "authSelect " +
                                      (batchForwardList.indexOf(id) > -1
                                        ? "selected"
                                        : "")
                                    }
                                    onClick={this.selectBatch(res)}
                                  >
                                    <i
                                      className={
                                        batchForwardList.indexOf(id) > -1
                                          ? "icon-bsy-select"
                                          : "icon-bsy-check2"
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                            {
                              <>
                                {
                                  // res.isUrged && <div className="todoIsUrged">催</div>
                                }
                                <div className="creator-info">
                                  {y.indexOf("://") > -1 ? (
                                    <img
                                      className="headPortrait"
                                      src={y}
                                      alt=""
                                    />
                                  ) : (
                                    <div
                                      className={
                                        "user-portrait-name color-" + bg.color
                                      }
                                    >
                                      {this.highlighterText(bg.name)}
                                    </div>
                                  )}
                                </div>
                                <div className="creator-name">
                                  <div className="name">
                                    {this.highlighterText(s)}
                                  </div>
                                </div>
                              </>
                            }

                            <div className="flow-brief-list">
                              <ul
                                className={
                                  "flow-brief " +
                                  (res.data.length > 3 ? "brief-more" : "")
                                }
                              >
                                {res.data.map((res1, index) => {
                                  if (index >= 3) {
                                    return "";
                                  }
                                  return (
                                    <li className="brief-item">
                                      <span className="brief-label">
                                        {res1.label}
                                      </span>
                                      <span className="brief-val">
                                        <span className="sep">：</span>
                                        {this.highlighterText(
                                          this._formatData(res1)
                                        )}
                                      </span>
                                    </li>
                                  );
                                })}
                              </ul>
                              {res.data.length > 3 ? (
                                <ul className="flow-brief brief-more">
                                  {res.data.map((res1, index) => {
                                    if (index < 3) {
                                      return "";
                                    }
                                    return (
                                      <li className="brief-item">
                                        <span className="brief-label">
                                          {res1.label}
                                        </span>
                                        <span className="brief-val">
                                          <span className="sep">：</span>
                                          {this.highlighterText(
                                            this._formatData(res1)
                                          )}
                                        </span>
                                      </li>
                                    );
                                  })}
                                </ul>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          {entryId === "todo"
                            ? generateQuickBtn(res, (type) => {
                              this.onFlowItemQuickEvent(res, type);
                            })
                            : ""}
                        </li>
                      );
                    })
                  ) : (
                    <div className="flow-empty participated">
                      <span>
                        {entryId !== "todo"
                          ? React.language("nothing.error.tip1")
                          : React.language("nothing.error.tip")}
                      </span>
                    </div>
                  )}
                </ul>
              )}
              {page !== 0 &&
                flowFormData.length > 0 &&
                (scrollDataLength < count ? (
                  <div className="loadStart">{React.language("loading")}</div>
                ) : (
                  <div className="loadStart">
                    {React.language("module.title5")}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </>
    );
  };

  toDataManage = () => {
    const { entryId, appId, entryname, appName } = this.state;
    this.props.history.push({
      pathname: `${window.rootDirectroy}/team/app/${appId}/form/${entryId}/datamanage`,
      state: { entryname: entryname, appname: appName },
    });
  };

  renderPlaceholder = () => {
    return "";
  };

  renderSidebar = () => {
    return "";
    // const { isExpand } = this.state;
    // return (
    //   <div className="bsy-sidebar-container" onClick={this.props._initHideMenu}>
    //     <div className="icon-container">
    //       <i
    //         className={
    //           isExpand
    //             ? "bs-icon-iconcaidanzhankai"
    //             : "bs-icon-iconcaidanshouqi"
    //         }
    //       />
    //     </div>
    //   </div>
    // );
  };

  renderContent = () => {
    let {
      loadSuccess,
      showContentEmpty,
      entryId,
      type,
      appId,
      dashConfig,
      allComponentDash,
      isDashFull,
      isShowCloseTip,
      isExpand,
      formAuthGroups,
      authGroupId,
      authGroupMap,
      allFilterList,
    } = this.state;
    if (dashConfig.components && !JSON.stringify(dashConfig) !== "{}") {
      var cddashConfig = Object.fromEntries(
        Object.entries(dashConfig.components).filter(([, val]) => {
          return !val["parentsId"];
        })
      );
      dashConfig.components = cddashConfig;
    }

    const { rel } = this;
    let rootTokenDashClass =
      "rootTokenDashClass" + window.FX.STATIC.appId + window.FX.STATIC.entryId;
    if (entryId === "todo") {
      let allCc = 0;
      for (let i = 0; i < allFilterList.length; i++) {
        allCc += allFilterList[i].count;
      }

      const flowCount = document.querySelector("#menutodo .flow-count");
      if (flowCount) {
        if (allCc > 0) {
          flowCount.style.display = "";
          flowCount.innerHTML = allCc + "";
          flowCount.setAttribute(
            "title",
            React.language("flow.todo.count", { count: allCc })
          );
        } else {
          flowCount.style.display = "none";
        }
      }
    }

    if (showContentEmpty) {
      if (type === "flow") {
        return this.flowListPane();
      }
      if (type === "form") {
        return (
          <>
            <div className="bsy-frame-path-container">
              {this.renderSidebar()}
              <div
                className="bsy-frame-path"
                ref={this.path}
                key={"breadcrumb-" + this.renderindex}
              >
                <div className="bsy-breadcrumb" ref={this.breadcrumb}>
                  {BsyUtils.isObjectEmpty(formAuthGroups) ? (
                    <div
                      className={"entry-name aa11 " + type}
                      ref={this.entryname}
                    >
                      {this.state.entryname}
                    </div>
                  ) : (
                    <BsySelect
                      // customCls={" form-view "}
                      allowBlank={false}
                      searchable={false}
                      width={200}
                      value={authGroupId}
                      items={formAuthGroups}
                      onStopEdit={(val) => {
                        const bb = formAuthGroups.map((d) => {
                          d.selected = false;
                          if (d.value === val) d.selected = true;
                          return d;
                        });
                        this.renderIndex++;
                        this.setState(
                          {
                            authGroupId: val,
                            formAuthGroups: bb,
                          },
                          () => {
                            let j = BsyUtils.Store.getKey("authGroup", {
                              appId: appId,
                              entryId: entryId,
                            });
                            BsyUtils.Store.set(j, val);
                            // if (val === -1) {
                            //     this._setFormView(val, authGroupMap, formConfig)
                            // }
                          }
                        );
                      }}
                    ></BsySelect>
                  )}
                </div>
                <div className="frame-path-right">
                  {(BsyUtils.hasTokenEdit(appId) ||
                    (this.props && this.state.editAuth)) &&
                    type === "form" ? (
                    <div
                      className="form-path-tiem to-Manage"
                      onClick={this.toDataManage}
                      style={{
                        left: "auto",
                        right: 122,
                      }}
                    >
                      <i className="icon icon-bsy-datatable-manage"></i>
                      <span>{React.language("form.data")}</span>
                    </div>
                  ) : (
                    ""
                  )}
                  {(BsyUtils.hasTokenEdit(appId) ||
                    (this.props &&
                      this.state.editAuth &&
                      this.state.appType !== 4)) && (
                      <div
                        className="form-path-tiem edit-form"
                        onClick={this.toEditForm}
                      >
                        <i className="icon icon-bsy-reportmenu-1"></i>
                        {React.language("edit")}
                      </div>
                    )}
                </div>
              </div>
              <BsySystemRightMenu search={false} />
            </div>

            {authGroupId !== -1 && authGroupMap && authGroupMap[authGroupId] ? (
              <div
                className="bsy-frame-entry-content"
                key={"render-" + this.renderIndex}
                ref={this.content}
              >
                {this.renderDataTable()}
              </div>
            ) : (
              <div
                className="bsy-frame-entry-content"
                key={"render-" + this.renderIndex}
                ref={this.content}
              >
                {this.renderForm()}
              </div>
            )}
          </>
        );
      }
      if (type === "dash" || type === "scenes") {
        return (
          <>
            <div className="bsy-frame-path-container">
              {this.renderSidebar()}
              <div className="bsy-frame-path">
                <div className="bsy-breadcrumb">
                  <div
                    className="entry-name"
                    style={{
                      display: "block",
                    }}
                  >
                    {this.state.entryname}
                  </div>
                </div>

                <div className="frame-path-right">
                  {
                    //钉钉状态下全屏有诸多问题
                    !this._isInDingTalk() && <div
                      className="form-path-tiem form-view Full"
                      style={{
                        left: "auto",
                        right: 122,
                      }}
                      onClick={this.onFullDash}
                      onMouseEnter={(e) => {
                        if (
                          this.bsyDashContext.props.autoRefresh &&
                          this.bsyDashContext.props.autoRefresh &&
                          this.bsyDashContext.props.autoRefresh.enabled
                        ) {
                          this.showTooltip(
                            e.currentTarget,
                            React.language("dash.full.autoRefresh.tip"),
                            "bottom",
                            10
                          );
                        }
                      }}
                      onMouseLeave={this.hideTooltip}
                    >
                      <i
                        className={
                          isDashFull
                            ? "icon icon-bsy-iconsuoxiao"
                            : "icon icon-bsy-iconquanping"
                        }
                      />
                      <span>
                        {isDashFull
                          ? React.language("exitfullScreen")
                          : React.language("fullScreen")}
                      </span>
                    </div>
                  }


                  {dashConfig.cacheFilter ? (
                    <>
                      <div
                        data-tip={React.language("reset.filter")}
                        data-place={"bottom"}
                        data-type={window.mode}
                        data-html={true}
                        className="form-path-tiem dash-filter-reset"
                        onClick={this.onResetFilter}
                      >
                        <i className={"icon icon-async"} />
                        <span>{React.language("richtext.reset")}</span>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {dashConfig.showFilter ? (
                    <>
                      <div
                        className="form-path-tiem dash-filter-rel"
                        data-tip={
                          rel === "and"
                            ? React.language("reset.filter.and.tip")
                            : React.language("reset.filter.or.tip")
                        }
                        data-place={"bottom"}
                        data-type={window.mode}
                        data-html={true}
                      >
                        <BsySelect
                          getContext={this.getDashRelContext}
                          allowBlank={false}
                          searchable={false}
                          value={rel}
                          upWidth={100}
                          theme={
                            dashConfig.styles &&
                            dashConfig.styles.theme &&
                            dashConfig.styles.theme.name
                          }
                          items={[
                            {
                              value: "and",
                              text: React.language("filter.rel.and"),
                            },
                            {
                              value: "or",
                              text: React.language("filter.rel.or"),
                            },
                          ]}
                          onStopEdit={(val) => {
                            this.bsyDashContext.setRel(val);
                            this.rel = val;
                          }}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {(BsyUtils.hasTokenEdit(appId) ||
                    (this.props &&
                      this.state.editAuth &&
                      this.state.appType !== 4)) && (
                      <div
                        className="form-path-tiem edit-form"
                        onClick={this.toEditForm}
                      >
                        <i className="icon icon-bsy-reportmenu-1"></i>
                        {React.language("edit")}
                      </div>
                    )}
                </div>
              </div>
              <BsySystemRightMenu search={false} />
              {/* //钉钉pc端全屏状态展示 */}

              {
                isDashFull && isShowCloseTip && <div className="t-close-top-tip" onClick={this.closeDashFull}><i className="icon-close-large"></i></div>
              }
            </div>

            <div className="bsy-frame-entry-content" ref={this.dashContent}>
              {type === "dash" || type === "scenes" ? (
                <BsyDashContainer
                  key={`dash${dashConfig.appId}${dashConfig.entryId}`}
                  {...dashConfig}
                  allComponentDash={allComponentDash}
                  isDashFull={isDashFull}
                  isExpand={isExpand}
                  rootTokenDashclassName={rootTokenDashClass}
                  rel={rel}
                  getContext={this.getDashContext}
                />
              ) : (
                ""
              )}
            </div>
          </>
        );
      }

      if (type === "report") {
        return (
          <>
            <div className="bsy-frame-path-container">
              {this.renderSidebar()}
              <div
                className="bsy-frame-path"
                ref={this.path}
                key={"breadcrumb-" + this.renderindex}
              >
                <div className="bsy-breadcrumb" ref={this.breadcrumb}>
                  <div
                    className={"entry-name aa11 " + type}
                    ref={this.entryname}
                  >
                    {" "}
                    {this.state.entryname}
                  </div>{" "}
                  :
                </div>
              </div>
              <BsySystemRightMenu search={false} />
            </div>

            <div
              className="bsy-frame-entry-content"
              key={"render-" + this.renderIndex}
              ref={this.content}
            ></div>
          </>
        );
      }
    }
    if (
      loadSuccess &&
      ["todo", "create", "transactors", "cc"].indexOf(entryId) > -1
    ) {
      return (
        <>
          <div className="bsy-frame-path-container">
            {this.renderSidebar()}
            <div className="bsy-frame-path" ref={this.path}>
              <div className="bsy-breadcrumb" ref={this.breadcrumb}></div>
            </div>
            <BsySystemRightMenu search={false} />
          </div>
          <div className="bsy-frame-entry-content">
            <div
              className="flow-pane fx_flow_list"
              style={{ background: "rgb(245, 251, 255)" }}
            >
              <div className="flow-empty participated">
                <span>
                  {entryId !== "todo"
                    ? React.language("nothing.error.tip1")
                    : React.language("nothing.error.tip")}
                </span>
              </div>
            </div>
          </div>
        </>
      );
    }
    return this.renderPlaceholder();
  };

  render() {
    const { titleName, isLoading, type } = this.state;
    setPageTitle(titleName || "");
    return (

      <div
        key={[this.state.entryId, this.state.appId].join("@")}
        className={"bsy-content " + type}
        style={{ filter: isLoading ? "blur(1px)" : "none" }}
      >
        {this.renderContent()}
      </div>

    );
  }
}
export default withRouter(Content);

export class ShowFlowFormList extends BsyWidget {
  constructor(props) {
    super({
      ...props,
    });
    this.state = {
      flowFormList: [...props.allFilterList],
      fArray: [...props.fArray],
      entryId: props.entryId,
    };

    this.seachRef = React.createRef();
    this.listRef = React.createRef();
  }

  searchValue = (key) => {
    const { allFilterList } = this.props;

    if (!key) {
      this.setState({
        flowFormList: [...allFilterList],
      });
      return;
    }

    let lists = allFilterList.filter((e) => {
      if (e.name) {
        if (e.name.indexOf(key) !== -1) {
          return true;
        }
      }
    });
    this.setState({
      flowFormList: [...lists],
    });
  };

  render() {
    let that = this;
    // const {   } = this.options
    const { flowFormList, fArray, entryId } = this.state;

    return (
      <>
        <div className="allFilterList">
          <BsySearchInput
            onSearch={(val) => {
              that.searchValue(val);
            }}
            type={window.mode}
          // iconName="icon-bsy-reportmenu-0"
          ></BsySearchInput>
          <div className="bsy-op-menu-pane all-form">
            <ul className="menu-pane">
              {flowFormList.map((res) => {
                if (fArray.indexOf(res.entryId || res.appId) > -1) {
                  res.show = true;
                } else {
                  res.show = false;
                }
                return (
                  <li
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      that.props.selectFlowForm(res);
                    }}
                    key={res.entryId}
                    className={
                      "menu-item " +
                      (res.show ? "show " : " ") +
                      (res.selected ? "selected" : "")
                    }
                    title={res.name}
                  >
                    <i className={"icon-form-flow icon-bby-form-" + res.icon} />
                    <span>{res.name}</span>
                    {entryId === "todo" && res.count > 0 && (
                      <span
                        style={{ fontSize: 12, marginLeft: 8, paddingLeft: 0 }}
                      >
                        ({res.count})
                      </span>
                    )}
                    {/* {res.selected && <i className="icon-ok" />} */}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </>
    );
  }
}
